/**
 * This file have constant for MATH keys and their Alter keys
 * A Math key have multiple property like
 *  type: CONSTANTS.CV_FRACTION_TYPE, // Type of MAth key
    group: CONSTANTS.CV_BRANCHING_GRP, // Group of Math key
    width: 3, // Width 3 means it will take 3 col if 6 , it will double of normal key
    className: '_number-blue', // extra class we want to add to key
    alterKeys: [], // Alter key Array, blank [] if no alter key
 */
import * as CONSTANTS from './canvasSymTypes';
import { ICommonKey, IMathKey, ISelectedKey } from '../models/IMathKeys';
export const BUTTON_ID = {
  UNITS: 'UNITS',
  ABC: 'ABC',
  BRACKET_LEFT: 'BRACKET_LEFT',
  BRACKET_RIGHT: 'BRACKET_RIGHT',
  CONSTANTS: 'CONSTANTS',
  MISC_MATH: 'MISC_MATH',
  SUMMATION: 'SUMMATION',
  LINE: 'LINE',
  BLANK: 'BLANK',
  DIVIDE: 'DIVIDE',
  MULTIPLY: 'MULTIPLY',
  MINUS: 'MINUS',
  PLUS: 'PLUS',
  NEG: 'NEG',
  LESS_THAN: 'LESS_THAN',
  DECIMAL: 'DECIMAL',
  GREATER_THAN: 'GREATER_THAN',
  EQUAL: 'EQUAL',
  SQRT: 'SQRT',
  EXPO: 'EXPO',
  EXPO_GRID: 'EXPO_GRID',
  FRACTION: 'FRACTION',
  FRACTION_GRID: 'FRACTION_GRID',
  FRACTION_GRID_SIGN: 'FRACTION_GRID_SIGN',
  VAR_X_3: 'VAR_X_3',
  VAR_X_4: 'VAR_X_4',
  VAR_Y_3: 'VAR_Y_3',
  VAR_Y_4: 'VAR_Y_4',
  VAR_Z: 'VAR_Z',
  VAR_X_SQR: 'VAR_X_SQR',
  EXPO_E: 'EXPO_E',
  SPACE: 'SPACE',
  ln: 'ln',
  log: 'log',
  sin: 'sin',
  cos: 'cos',
  tan: 'tan',
  CROSS_OF: 'CROSS_OF',
  DIVISION: 'DIVISION',
  KEY_ID_DX: 'KEY_ID_DX',
  KEY_ID_DY: 'KEY_ID_DY',
  // Geometry keyboard buttons
  GEO_THEREFORE: 'GEO_THEREFORE',
  GEO_ANGLE: 'GEO_ANGLE',
  GEO_MEASURE_ANGLE: 'GEO_MEASURE_ANGLE',
  GEO_TRIANGLE: 'GEO_TRIANGLE',
  GEO_LINE_SEG: 'GEO_LINE_SEG',
  GEO_VAR_A: 'GEO_VAR_A',
  GEO_VAR_B: 'GEO_VAR_B',
  GEO_VAR_C: 'GEO_VAR_C',
  GEO_PRIME: 'GEO_PRIME',
  GEO_PARALLEL: 'GEO_PARALLEL',
  GEO_PERPENDICULAR: 'GEO_PERPENDICULAR',
  GEO_SIMILAR: 'GEO_SIMILAR',
  GEO_CONGRUENT: 'GEO_CONGRUENT',
  GEO_RIGHT_ANGLE: 'GEO_RIGHT_ANGLE',
};
export const ALTER_KEYS = {
  UNITS: {
    LEVEL_2_3_4: [
      CONSTANTS.KEY_ID_PERCENT,
      CONSTANTS.KEY_ID_DOLLAR,
      CONSTANTS.KEY_ID_CENT,
      CONSTANTS.KEY_ID_DEGREE,
      CONSTANTS.KEY_ID_FT,
      CONSTANTS.KEY_ID_IN,
      CONSTANTS.KEY_ID_FT_MARK,
      CONSTANTS.KEY_ID_IN_MARK,
      CONSTANTS.KEY_ID_LB,
      CONSTANTS.KEY_ID_OUNCE,
      CONSTANTS.KEY_ID_METER,
      CONSTANTS.KEY_ID_CM,
      CONSTANTS.KEY_ID_BR_POUND,
      CONSTANTS.KEY_ID_EURO,
      CONSTANTS.KEY_ID_LITER,
      CONSTANTS.KEY_ID_KG,
    ],
    LEVEL_1: [
      CONSTANTS.KEY_ID_DOLLAR,
      CONSTANTS.KEY_ID_CENT,
      CONSTANTS.KEY_ID_FT_MARK,
      CONSTANTS.KEY_ID_IN_MARK,
      CONSTANTS.KEY_ID_AM,
      CONSTANTS.KEY_ID_PM,
      CONSTANTS.KEY_ID_IN,
      CONSTANTS.KEY_ID_DEGREE,
      CONSTANTS.KEY_ID_MONEY_Q,
      CONSTANTS.KEY_ID_MONEY_D,
      CONSTANTS.KEY_ID_MONEY_N,
      CONSTANTS.KEY_ID_MONEY_P,
    ],
    // Geometry keyboard units popup: 5 rows x 4 columns.
    GEO: [
      CONSTANTS.KEY_ID_DEGREE,
      CONSTANTS.KEY_ID_PERCENT,
      CONSTANTS.KEY_ID_U,
      CONSTANTS.KEY_ID_U_SQUARED,
      CONSTANTS.KEY_ID_IN,
      CONSTANTS.KEY_ID_FT,
      CONSTANTS.KEY_ID_IN_SQR,
      CONSTANTS.KEY_ID_FT_SQR,
      CONSTANTS.KEY_ID_YD,
      CONSTANTS.KEY_ID_MI,
      CONSTANTS.KEY_ID_U_CUBE,
      CONSTANTS.KEY_ID_IN_CUBE,
      CONSTANTS.KEY_ID_CM,
      CONSTANTS.KEY_ID_METER,
      CONSTANTS.KEY_ID_KM,
      CONSTANTS.KEY_ID_MM,
      CONSTANTS.KEY_ID_CM_SQR,
      CONSTANTS.KEY_ID_M_SQR,
      CONSTANTS.KEY_ID_LITER,
      CONSTANTS.KEY_ID_CM_CUBE,
    ],
  },
  BRACKET_LEFT: [CONSTANTS.KEY_ID_PAREN_LEFT, CONSTANTS.KEY_ID_SQ_BRACKET_LEFT, CONSTANTS.KEY_ID_CURLY_LEFT],
  BRACKET_RIGHT: [CONSTANTS.KEY_ID_PAREN_RIGHT, CONSTANTS.KEY_ID_SQ_BRACKET_RIGHT, CONSTANTS.KEY_ID_CURLY_RIGHT],
  CONSTANTS: {
    LEVEL_4: [CONSTANTS.KEY_ID_PI, CONSTANTS.KEY_ID_INFINITY, CONSTANTS.KEY_ID_E, CONSTANTS.KEY_ID_I, CONSTANTS.KEY_ID_AVOGADRO],
    LEVEL_3: [CONSTANTS.KEY_ID_PI, CONSTANTS.KEY_ID_INFINITY],
  },
  MISC_MATH: {
    LEVEL_4_3: [
      CONSTANTS.KEY_ID_COLON,
      CONSTANTS.KEY_ID_COMMA,
      CONSTANTS.KEY_ID_FACTORIAL,
      CONSTANTS.KEY_ID_ANGLE,
      CONSTANTS.KEY_ID_ANGLE_VALUE,
      CONSTANTS.KEY_ID_CHECKMARK,
      CONSTANTS.KEY_ID_UNION,
      CONSTANTS.KEY_ID_INTERSECT,
      CONSTANTS.KEY_ID_ELEMENT,
      CONSTANTS.KEY_ID_ABSOLUTE,
      CONSTANTS.KEY_ID_PLUS_MINUS,
      CONSTANTS.KEY_ID_DELTA,
      CONSTANTS.KEY_ID_LEFT_ARROW,
      CONSTANTS.KEY_ID_CHEM_ARROW,
      CONSTANTS.KEY_ID_CHEM_DB_ARROW,
      // CONSTANTS.KEY_ID_DER_F,
      // CONSTANTS.KEY_ID_EMPTY,
      // CONSTANTS.KEY_ID_EMPTY,
    ],
    LEVEL_2: [
      CONSTANTS.KEY_ID_R,
      CONSTANTS.KEY_ID_COMMA,
      CONSTANTS.KEY_ID_COLON,
      CONSTANTS.KEY_ID_ANGLE_VALUE,
      CONSTANTS.KEY_ID_ANGLE,
      CONSTANTS.KEY_ID_CHECKMARK,
      CONSTANTS.KEY_ID_FRACTION,
      CONSTANTS.KEY_ID_LEFT_ARROW,
      CONSTANTS.KEY_ID_EMPTY,
    ],
    LEVEL_1: [CONSTANTS.KEY_ID_COLON, CONSTANTS.KEY_ID_COMMA, CONSTANTS.KEY_ID_DECIMAL, CONSTANTS.KEY_ID_CHECKMARK],
    // Geometry keyboard misc-math popup: 12 items shown 3 wide (4 rows) via popupColumns: 3.
    GEO: [
      CONSTANTS.KEY_ID_COLON,
      CONSTANTS.KEY_ID_COMMA,
      CONSTANTS.KEY_ID_FACTORIAL,
      CONSTANTS.KEY_ID_UNION,
      CONSTANTS.KEY_ID_INTERSECT,
      CONSTANTS.KEY_ID_ELEMENT,
      CONSTANTS.KEY_ID_ABSOLUTE,
      CONSTANTS.KEY_ID_PLUS_MINUS,
      CONSTANTS.KEY_ID_DELTA,
      CONSTANTS.KEY_ID_LEFT_ARROW,
      CONSTANTS.KEY_ID_CHEM_ARROW,
      CONSTANTS.KEY_ID_CHECKMARK,
    ],
  },
  MULTIPLY: {
    LEVEL_3_4_5: [CONSTANTS.KEY_ID_MULTIPLY_1, CONSTANTS.KEY_ID_MULTIPLY_2, CONSTANTS.KEY_ID_MULTIPLY_3],
    LEVEL_2: [CONSTANTS.KEY_ID_MULTIPLY_3, CONSTANTS.KEY_ID_MULTIPLY_2, CONSTANTS.KEY_ID_MULTIPLY_1],
  },
  DIVIDE: {
    LEVEL_2: [CONSTANTS.KEY_ID_DIVIDE_2, CONSTANTS.KEY_ID_DIVIDE_1],
    LEVEL_3_4_5: [CONSTANTS.KEY_ID_DIVIDE_1, CONSTANTS.KEY_ID_DIVIDE_2],
  },
  SUMMATION: [
    CONSTANTS.KEY_ID_SUMMATION,
    CONSTANTS.KEY_ID_SUMMATION_1,
    CONSTANTS.KEY_ID_SUMMATION_2,
    CONSTANTS.KEY_ID_INTEGRAL,
    CONSTANTS.KEY_ID_INTEGRAL_1,
    CONSTANTS.KEY_ID_VERTICAL_LINE,
  ],
  LESS_THAN: {
    LEVEL_3_4: [CONSTANTS.KEY_ID_LESS_THAN, CONSTANTS.KEY_ID_LESS_THAN_EQ],
    LEVEL_1_2: [CONSTANTS.KEY_ID_LESS_THAN, CONSTANTS.KEY_ID_LESS_THAN_EQ, CONSTANTS.KEY_ID_NOT_EQUAL],
  },
  GREATER_THAN: [CONSTANTS.KEY_ID_GREATER_THAN, CONSTANTS.KEY_ID_GREATER_THAN_EQ],
  EQUAL: [CONSTANTS.KEY_ID_EQUAL, CONSTANTS.KEY_ID_NOT_EQUAL, CONSTANTS.KEY_ID_APPROX_EQUAL, CONSTANTS.KEY_ID_LINE],
  SQRT: [CONSTANTS.KEY_ID_SQRT, CONSTANTS.KEY_ID_ROOT],
  EXPO: [CONSTANTS.KEY_ID_EXPONENT, CONSTANTS.KEY_ID_EXPONENT_1, CONSTANTS.KEY_ID_EXPONENT_2],
  VAR_X_3: [
    CONSTANTS.KEY_ID_X,
    CONSTANTS.KEY_ID_Y,
    CONSTANTS.KEY_ID_Z,
    CONSTANTS.KEY_ID_W,
    CONSTANTS.KEY_ID_A,
    CONSTANTS.KEY_ID_B,
    CONSTANTS.KEY_ID_C,
    CONSTANTS.KEY_ID_N,
    CONSTANTS.KEY_ID_H,
    CONSTANTS.KEY_ID_R,
    CONSTANTS.KEY_ID_S,
    CONSTANTS.KEY_ID_T,
    CONSTANTS.KEY_ID_FX,
    CONSTANTS.KEY_ID_X_SQR,
    CONSTANTS.KEY_ID_THETA,
    CONSTANTS.KEY_ID_P,
  ],
  VAR_X_4: [
    CONSTANTS.KEY_ID_X,
    CONSTANTS.KEY_ID_Y,
    CONSTANTS.KEY_ID_Z,
    CONSTANTS.KEY_ID_P,
    CONSTANTS.KEY_ID_A,
    CONSTANTS.KEY_ID_B,
    CONSTANTS.KEY_ID_C,
    CONSTANTS.KEY_ID_N,
    CONSTANTS.KEY_ID_H,
    CONSTANTS.KEY_ID_R,
    CONSTANTS.KEY_ID_S,
    CONSTANTS.KEY_ID_T,
    CONSTANTS.KEY_ID_FX,
    CONSTANTS.KEY_ID_LAMBDA,
    CONSTANTS.KEY_ID_THETA,
    CONSTANTS.KEY_ID_MU,
  ],
  VAR_Y_3: [
    CONSTANTS.KEY_ID_X,
    CONSTANTS.KEY_ID_Y,
    CONSTANTS.KEY_ID_Z,
    CONSTANTS.KEY_ID_W,
    CONSTANTS.KEY_ID_A,
    CONSTANTS.KEY_ID_B,
    CONSTANTS.KEY_ID_C,
    CONSTANTS.KEY_ID_N,
    CONSTANTS.KEY_ID_H,
    CONSTANTS.KEY_ID_R,
    CONSTANTS.KEY_ID_S,
    CONSTANTS.KEY_ID_T,
    CONSTANTS.KEY_ID_FX,
    CONSTANTS.KEY_ID_Y_SQR,
    CONSTANTS.KEY_ID_THETA,
    CONSTANTS.KEY_ID_P,
  ],
  VAR_Y_4: [
    CONSTANTS.KEY_ID_X,
    CONSTANTS.KEY_ID_Y,
    CONSTANTS.KEY_ID_Z,
    CONSTANTS.KEY_ID_P,
    CONSTANTS.KEY_ID_A,
    CONSTANTS.KEY_ID_B,
    CONSTANTS.KEY_ID_C,
    CONSTANTS.KEY_ID_N,
    CONSTANTS.KEY_ID_H,
    CONSTANTS.KEY_ID_R,
    CONSTANTS.KEY_ID_S,
    CONSTANTS.KEY_ID_T,
    CONSTANTS.KEY_ID_FX,
    CONSTANTS.KEY_ID_LAMBDA,
    CONSTANTS.KEY_ID_THETA,
    CONSTANTS.KEY_ID_MU,
  ],
  VAR_Z: [
    CONSTANTS.KEY_ID_X,
    CONSTANTS.KEY_ID_Y,
    CONSTANTS.KEY_ID_Z,
    CONSTANTS.KEY_ID_W,
    CONSTANTS.KEY_ID_A,
    CONSTANTS.KEY_ID_B,
    CONSTANTS.KEY_ID_C,
    CONSTANTS.KEY_ID_N,
    CONSTANTS.KEY_ID_H,
    CONSTANTS.KEY_ID_R,
    CONSTANTS.KEY_ID_S,
    CONSTANTS.KEY_ID_T,
    CONSTANTS.KEY_ID_FX,
    CONSTANTS.KEY_ID_P,
    CONSTANTS.KEY_ID_THETA,
    CONSTANTS.KEY_ID_MU,
  ],
  VAR_X_SQR: [
    CONSTANTS.KEY_ID_X_SQR,
    CONSTANTS.KEY_ID_Y_SQR,
    CONSTANTS.KEY_ID_Z_SQR,
    CONSTANTS.KEY_ID_A_SQR,
    CONSTANTS.KEY_ID_B_SQR,
    CONSTANTS.KEY_ID_C_SQR,
    CONSTANTS.KEY_ID_R_SQR,
    CONSTANTS.KEY_ID_T_SQR,
    CONSTANTS.KEY_ID_N_SQR,
  ],
  LOG: [CONSTANTS.KEY_ID_LOG, CONSTANTS.KEY_ID_LOG_A, CONSTANTS.KEY_ID_LN],
  TRIG: [
    CONSTANTS.KEY_ID_SIN,
    CONSTANTS.KEY_ID_COS,
    CONSTANTS.KEY_ID_TAN,
    CONSTANTS.KEY_ID_SIN_SQR,
    CONSTANTS.KEY_ID_COS_SQR,
    CONSTANTS.KEY_ID_TAN_SQR,
    CONSTANTS.KEY_ID_INVERSE_SIN,
    CONSTANTS.KEY_ID_INVERSE_COS,
    CONSTANTS.KEY_ID_INVERSE_TAN,
    CONSTANTS.KEY_ID_CSC,
    CONSTANTS.KEY_ID_SEC,
    CONSTANTS.KEY_ID_COT,
    CONSTANTS.KEY_ID_CSC_SQR,
    CONSTANTS.KEY_ID_SEC_SQR,
    CONSTANTS.KEY_ID_COT_SQR,
    CONSTANTS.KEY_ID_INVERSE_CSC,
    CONSTANTS.KEY_ID_INVERSE_SEC,
    CONSTANTS.KEY_ID_INVERSE_COT,
  ],
  // geometry keyboard trig popup: 2 rows of 3 (sin/cos/tan, then inverse sin/cos/tan)
  GEO_TRIG: [
    CONSTANTS.KEY_ID_SIN,
    CONSTANTS.KEY_ID_COS,
    CONSTANTS.KEY_ID_TAN,
    CONSTANTS.KEY_ID_INVERSE_SIN,
    CONSTANTS.KEY_ID_INVERSE_COS,
    CONSTANTS.KEY_ID_INVERSE_TAN,
  ],
  CROSS_OF: {
    LEVEL_1_2: [CONSTANTS.KEY_ID_CROSSOFF_2, CONSTANTS.KEY_ID_CROSSOFF_1, CONSTANTS.KEY_ID_CROSSOFF_3],
    LEVEL_OTHER: [CONSTANTS.KEY_ID_CROSSOFF_1, CONSTANTS.KEY_ID_CROSSOFF_2, CONSTANTS.KEY_ID_CROSSOFF_3],
  },
  BLANK: [
    CONSTANTS.KEY_ID_BLANK,
    CONSTANTS.KEY_ID_X,
    CONSTANTS.KEY_ID_Y,
    CONSTANTS.KEY_ID_A,
    CONSTANTS.KEY_ID_B,
    CONSTANTS.KEY_ID_C,
    CONSTANTS.KEY_ID_R,
    CONSTANTS.KEY_ID_N,
    CONSTANTS.KEY_ID_T,
    CONSTANTS.KEY_ID_SIN,
    CONSTANTS.KEY_ID_COS,
    CONSTANTS.KEY_ID_TAN,
    CONSTANTS.KEY_ID_FX,
    CONSTANTS.KEY_ID_LOG,
    CONSTANTS.KEY_ID_LN,
    CONSTANTS.KEY_ID_EXPONENT,
    CONSTANTS.KEY_ID_E_EXPONENT,
    CONSTANTS.KEY_ID_FRACTION,
  ],
  SPACE: [CONSTANTS.KEY_ID_SPACE, CONSTANTS.KEY_ID_TAB, CONSTANTS.KEY_ID_TAB_EQUAL],
  DX: [CONSTANTS.KEY_ID_DX, CONSTANTS.KEY_ID_DER_1, CONSTANTS.KEY_ID_DER_2, CONSTANTS.KEY_ID_DER_3, CONSTANTS.KEY_ID_DER_4, CONSTANTS.KEY_ID_DER_5],
  DY: [CONSTANTS.KEY_ID_DY, CONSTANTS.KEY_ID_DER_F, CONSTANTS.KEY_ID_DER_F2, CONSTANTS.KEY_ID_DER_6, CONSTANTS.KEY_ID_DT, CONSTANTS.KEY_ID_DER_7],
  // Geometry keyboard popup lists
  GEO_TRIANGLE: [CONSTANTS.KEY_ID_TRIANGLE, CONSTANTS.KEY_ID_GEO_CIRCLE, CONSTANTS.KEY_ID_RIGHT_ANGLE],
  GEO_PRIME: [CONSTANTS.KEY_ID_PRIME, CONSTANTS.KEY_ID_DOUBLE_PRIME],
  GEO_THEREFORE: [CONSTANTS.KEY_ID_THEREFORE, CONSTANTS.KEY_ID_BECAUSE],
  GEO_LINE_SEG: [CONSTANTS.KEY_ID_GEO_LINE_SEG, CONSTANTS.KEY_ID_GEO_RAY, CONSTANTS.KEY_ID_GEO_LINE, CONSTANTS.KEY_ID_GEO_ARC],
  GEO_VAR_A: [
    CONSTANTS.KEY_ID_CAP_A,
    CONSTANTS.KEY_ID_CAP_D,
    CONSTANTS.KEY_ID_CAP_P,
    CONSTANTS.KEY_ID_CAP_M,
    CONSTANTS.KEY_ID_X,
    CONSTANTS.KEY_ID_Y,
    CONSTANTS.KEY_ID_Z,
    CONSTANTS.KEY_ID_H,
    CONSTANTS.KEY_ID_A,
    CONSTANTS.KEY_ID_R,
    CONSTANTS.KEY_ID_M,
    CONSTANTS.KEY_ID_THETA,
    CONSTANTS.KEY_ID_CAP_X,
    CONSTANTS.KEY_ID_CAP_G,
    CONSTANTS.KEY_ID_D,
    CONSTANTS.KEY_ID_L,
  ],
  GEO_VAR_B: [
    CONSTANTS.KEY_ID_CAP_B,
    CONSTANTS.KEY_ID_CAP_E,
    CONSTANTS.KEY_ID_CAP_Q,
    CONSTANTS.KEY_ID_CAP_N,
    CONSTANTS.KEY_ID_X,
    CONSTANTS.KEY_ID_Y,
    CONSTANTS.KEY_ID_Z,
    CONSTANTS.KEY_ID_H,
    CONSTANTS.KEY_ID_B,
    CONSTANTS.KEY_ID_R,
    CONSTANTS.KEY_ID_M,
    CONSTANTS.KEY_ID_THETA,
    CONSTANTS.KEY_ID_CAP_Y,
    CONSTANTS.KEY_ID_CAP_H,
    CONSTANTS.KEY_ID_S,
    CONSTANTS.KEY_ID_W,
  ],
  GEO_VAR_C: [
    CONSTANTS.KEY_ID_CAP_C,
    CONSTANTS.KEY_ID_CAP_F,
    CONSTANTS.KEY_ID_CAP_R,
    CONSTANTS.KEY_ID_CAP_O,
    CONSTANTS.KEY_ID_X,
    CONSTANTS.KEY_ID_Y,
    CONSTANTS.KEY_ID_Z,
    CONSTANTS.KEY_ID_H,
    CONSTANTS.KEY_ID_C,
    CONSTANTS.KEY_ID_R,
    CONSTANTS.KEY_ID_M,
    CONSTANTS.KEY_ID_THETA,
    CONSTANTS.KEY_ID_CAP_Z,
    CONSTANTS.KEY_ID_CAP_I,
    CONSTANTS.KEY_ID_K,
    CONSTANTS.KEY_ID_N,
  ],
  GEO_EQUAL: [
    CONSTANTS.KEY_ID_EQUAL,
    CONSTANTS.KEY_ID_NOT_EQUAL,
    CONSTANTS.KEY_ID_APPROX_EQUAL,
    CONSTANTS.KEY_ID_LESS_THAN,
    CONSTANTS.KEY_ID_LESS_THAN_EQ,
    CONSTANTS.KEY_ID_LINE,
    CONSTANTS.KEY_ID_GREATER_THAN,
    CONSTANTS.KEY_ID_GREATER_THAN_EQ,
    CONSTANTS.KEY_ID_NOT_SIMILAR,
  ],
};
/**
 * This object contains Common keys like group type alerkeys with etc for a MAth key
 */
export const COMMON_KEYS: { [key: string]: ICommonKey } = {
  UNITS: {
    type: CONSTANTS.CV_UNITS_TYPE,
    group: CONSTANTS.CV_LONG_GRP,
    width: 6,
    alterKeys: ALTER_KEYS.UNITS.LEVEL_2_3_4,
    alterKeysClass: '_unit',
  },
  BRACKET: {
    type: CONSTANTS.CV_BRACKET_TYPE,
    group: CONSTANTS.CV_BRACKET_GRP,
    width: 3,
    alterKeys: ALTER_KEYS.BRACKET_LEFT,
    className: '',
  },
  MISC: {
    type: CONSTANTS.CV_MISC_TYPE,
    group: CONSTANTS.CV_SIMPLE_GRP,
    width: 3,
    alterKeys: [],
  },
  SUMMATION: {
    type: CONSTANTS.CV_SUM_LIMIT_TYPE,
    group: CONSTANTS.CV_BRANCHING_GRP,
    width: 3,
    alterKeys: ALTER_KEYS.SUMMATION,
  },
  LINE: {
    type: CONSTANTS.CV_LINE_TYPE,
    group: CONSTANTS.CV_SPEC2_GRP,
    width: 3,
    className: '_size-big',
    alterKeys: [],
  },
  BLANK: {
    type: CONSTANTS.CV_NUM_TYPE,
    group: CONSTANTS.CV_SPEC2_GRP,
    width: 6,
    alterKeys: [],
    className: '',
  },
  NUMBER: {
    type: CONSTANTS.CV_NUM_TYPE,
    group: CONSTANTS.CV_SIMPLE_GRP,
    width: 3,
    alterKeys: [],
    className: '_number-color',
    contrastClassName: '_number-color-contrast',
    boldClassName: '_number-color-bold',
  },
  OPERATOR: {
    type: CONSTANTS.CV_OPERATOR_TYPE,
    group: CONSTANTS.CV_SIMPLE_GRP,
    width: 3,
    className: '_number-yellow',
    contrastClassName: '_number-yellow-contrast',
    boldClassName: '_number-yellow-bold',
    alterKeys: [],
  },
  SPECIAL: {
    type: CONSTANTS.CV_SPECIAL_TYPE,
    group: CONSTANTS.CV_SIMPLE_GRP,
    width: 3,
    alterKeys: [],
    className: '_number-color _size-big',
    contrastClassName: '_number-color-contrast _size-big',
  },
  SPACE: {
    type: CONSTANTS.CV_SPECIAL_TYPE,
    group: CONSTANTS.CV_SIMPLE_GRP,
    width: 3,
    alterKeys: [],
    className: '',
    contrastClassName: '',
  },
  INQ_TYPE: {
    type: CONSTANTS.CV_EQUALS_INQ_TYPE,
    group: CONSTANTS.CV_SIMPLE_GRP,
    width: 3,
    alterKeys: [],
    className: '_number-green',
    contrastClassName: '_number-green-contrast',
    boldClassName: '_number-green-bold',
  },
  SQRT: {
    type: CONSTANTS.CV_DIV_SQRT_TYPE,
    group: CONSTANTS.CV_BRANCHING_GRP,
    width: 6,
    className: '_number-blue',
    contrastClassName: '_number-blue-contrast',
    alterKeys: [],
  },
  EXPO: {
    type: CONSTANTS.CV_EXP_SUB_TYPE,
    group: CONSTANTS.CV_BRANCHING_GRP,
    width: 3,
    className: '_number-blue',
    contrastClassName: '_number-blue-contrast',
    alterKeys: [],
  },
  FRACTION: {
    type: CONSTANTS.CV_FRACTION_TYPE,
    group: CONSTANTS.CV_BRANCHING_GRP,
    width: 3,
    className: '_number-blue',
    contrastClassName: '_number-blue-contrast',
    alterKeys: [],
  },
  FRACTION_GRID_SIGN: {
    type: CONSTANTS.CV_FRACTION_TYPE,
    group: CONSTANTS.CV_BRANCHING_GRP,
    width: 3,
    className: '',
    contrastClassName: '',
    alterKeys: [],
  },
  VAR: {
    type: CONSTANTS.CV_VAR_TYPE,
    group: CONSTANTS.CV_LONG_GRP,
    width: 3,
    className: '_number-blue',
    contrastClassName: '_number-blue-contrast',
    alterKeys: [],
    alterKeysClass: '_bottom-align',
  },
  LOG: {
    type: CONSTANTS.CV_LOG_LN_TYPE,
    group: CONSTANTS.CV_LONG_GRP,
    width: 3,
    className: '_number-blue font-23',
    contrastClassName: '_number-blue-contrast font-23',
    alterKeys: [],
  },
  TRIG: {
    type: CONSTANTS.CV_TRIG_TYPE,
    group: CONSTANTS.CV_LONG_GRP,
    width: 4,
    className: '_number-blue font-22',
    contrastClassName: '_number-blue-contrast font-22',
    alterKeys: [],
    alterKeysClass: '_bottom-align trig-up',
  },
  CROSS_OF: {
    type: CONSTANTS.CV_CROSSOFF_TYPE,
    group: CONSTANTS.CV_LONG_GRP,
    width: 3,
    className: '',
    alterKeys: [],
  },
  VAR_SQR: {
    type: CONSTANTS.CV_VAR_SQR_TYPE,
    group: CONSTANTS.CV_LONG_GRP,
    width: 3,
    className: '_number-blue',
    contrastClassName: '_number-blue-contrast',
    alterKeys: [],
    // alterKeysClass: '_bottom-align',
  },
  EMPTY: {
    alterKeys: [],
  },
  DX: {
    type: CONSTANTS.CV_DERIVATIVE_TYPE,
    group: CONSTANTS.CV_BRANCHING_GRP,
    width: 3,
    alterKeys: ALTER_KEYS.DX,
  },
  DY: {
    type: CONSTANTS.CV_DERIVATIVE_TYPE,
    group: CONSTANTS.CV_LONG_GRP,
    width: 3,
    alterKeys: ALTER_KEYS.DY,
  },
  // Below two are only used by canvas when reading back saved file content
  KEY_ID_DX: {
    type: CONSTANTS.CV_DERIVATIVE_TYPE,
    group: CONSTANTS.CV_BRANCHING_GRP,
    width: 3,
    alterKeys: ALTER_KEYS.DX,
  },
  KEY_ID_DY: {
    type: CONSTANTS.CV_DERIVATIVE_TYPE,
    group: CONSTANTS.CV_BRANCHING_GRP,
    width: 3,
    alterKeys: ALTER_KEYS.DY,
  },
  // Geometry keyboard common key templates
  GEO_SYMBOL: {
    type: CONSTANTS.CV_GEO_SYMBOL,
    group: CONSTANTS.CV_SIMPLE_GRP,
    width: 3,
    className: '_number-blue',
    contrastClassName: '_number-blue-contrast',
    alterKeys: [],
  },
  GEO_SHAPE: {
    type: CONSTANTS.CV_GEO_SHAPE,
    group: CONSTANTS.CV_SIMPLE_GRP,
    width: 3,
    className: '_number-blue',
    contrastClassName: '_number-blue-contrast',
    alterKeys: [],
  },
  GEO_PROOF: {
    type: CONSTANTS.CV_GEO_PROOF,
    group: CONSTANTS.CV_SIMPLE_GRP,
    width: 3,
    className: '',
    alterKeys: [],
  },
  GEO_MEASURE: {
    type: CONSTANTS.CV_GEO_SYMBOL,
    group: CONSTANTS.CV_LONG_GRP,
    width: 3,
    className: '_number-blue',
    contrastClassName: '_number-blue-contrast',
    alterKeys: [],
  },
  GEO_OVER_TEXT: {
    type: CONSTANTS.CV_GEO_OVER_TEXT,
    group: CONSTANTS.CV_BRANCHING_GRP,
    width: 3,
    className: '_number-blue',
    contrastClassName: '_number-blue-contrast',
    alterKeys: [],
  },
};
/**
 * This object contains all the mathkeys label and their value
 */
export const MATH_KEYS: {
  [key: string]: ISelectedKey;
} = {
  [CONSTANTS.KEY_ID_CM]: {
    key: CONSTANTS.KEY_ID_CM,
    label: CONSTANTS.KEY_ID_CM,
    commonkeyGroup: 'UNITS',
    fontClass: 'unit-trig-key-sm',
    ariaLabelKey: 'voiceControl.centimeters',
  },
  [CONSTANTS.KEY_ID_RUPEE]: {
    key: CONSTANTS.KEY_ID_RUPEE,
    label: CONSTANTS.KEY_ID_RUPEE,
    commonkeyGroup: 'UNITS',
    ariaLabelKey: 'voiceControl.rupee',
  },
  [CONSTANTS.KEY_ID_DOLLAR]: {
    key: CONSTANTS.KEY_ID_DOLLAR,
    label: CONSTANTS.KEY_ID_DOLLAR,
    commonkeyGroup: 'UNITS',
    ariaLabelKey: 'voiceControl.dollars',
  },
  [CONSTANTS.KEY_ID_CENT]: {
    key: CONSTANTS.KEY_ID_CENT,
    label: CONSTANTS.KEY_ID_CENT,
    commonkeyGroup: 'UNITS',
    ariaLabelKey: 'voiceControl.cents',
  },
  [CONSTANTS.KEY_ID_DEGREE]: {
    key: CONSTANTS.KEY_ID_DEGREE,
    label: CONSTANTS.KEY_ID_DEGREE,
    commonkeyGroup: 'UNITS',
    ariaLabelKey: 'voiceControl.degree',
  },
  [CONSTANTS.KEY_ID_FT]: {
    key: CONSTANTS.KEY_ID_FT,
    label: CONSTANTS.KEY_ID_FT,
    commonkeyGroup: 'UNITS',
    fontClass: 'unit-trig-key-sm',
    ariaLabelKey: 'voiceControl.feet',
  },
  [CONSTANTS.KEY_ID_PERCENT]: {
    key: CONSTANTS.KEY_ID_PERCENT,
    label: CONSTANTS.KEY_ID_PERCENT,
    commonkeyGroup: 'UNITS',
    fontClass: 'f-calibri',
    ariaLabelKey: 'voiceControl.percent',
  },
  [CONSTANTS.KEY_ID_IN]: {
    key: CONSTANTS.KEY_ID_IN,
    label: CONSTANTS.KEY_ID_IN,
    commonkeyGroup: 'UNITS',
    fontClass: 'unit-trig-key-sm',
    ariaLabelKey: 'voiceControl.inches',
  },
  [CONSTANTS.KEY_ID_FT_MARK]: {
    key: CONSTANTS.KEY_ID_FT_MARK,
    label: CONSTANTS.KEY_ID_FT_MARK,
    commonkeyGroup: 'UNITS',
    ariaLabelKey: 'voiceControl.feetMark',
  },
  [CONSTANTS.KEY_ID_LAMBDA]: {
    key: CONSTANTS.KEY_ID_LAMBDA,
    label: CONSTANTS.KEY_ID_LAMBDA,
    commonkeyGroup: 'VAR',
    ariaLabelKey: 'voiceControl.lambda',
  },
  [CONSTANTS.KEY_ID_IN_MARK]: {
    key: CONSTANTS.KEY_ID_IN_MARK,
    label: CONSTANTS.KEY_ID_IN_MARK,
    commonkeyGroup: 'UNITS',
    ariaLabelKey: 'voiceControl.inchesMark',
  },
  [CONSTANTS.KEY_ID_LB]: {
    key: CONSTANTS.KEY_ID_LB,
    label: CONSTANTS.KEY_ID_LB,
    commonkeyGroup: 'UNITS',
    ariaLabelKey: 'voiceControl.pounds',
  },
  [CONSTANTS.KEY_ID_OUNCE]: {
    key: CONSTANTS.KEY_ID_OUNCE,
    label: CONSTANTS.KEY_ID_OUNCE,
    commonkeyGroup: 'UNITS',
    ariaLabelKey: 'voiceControl.ounces',
  },
  [CONSTANTS.KEY_ID_METER]: {
    key: CONSTANTS.KEY_ID_METER,
    label: CONSTANTS.KEY_ID_METER,
    commonkeyGroup: 'UNITS',
    fontClass: 'unit-trig-key-sm',
    ariaLabelKey: 'voiceControl.meters',
  },
  [CONSTANTS.KEY_ID_MM]: {
    key: CONSTANTS.KEY_ID_MM,
    label: CONSTANTS.KEY_ID_MM,
    commonkeyGroup: 'UNITS',
    fontClass: 'unit-trig-key-sm',
    ariaLabelKey: 'voiceControl.millimeters',
  },
  [CONSTANTS.KEY_ID_KM]: {
    key: CONSTANTS.KEY_ID_KM,
    label: CONSTANTS.KEY_ID_KM,
    commonkeyGroup: 'UNITS',
    fontClass: 'unit-trig-key-sm',
    ariaLabelKey: 'voiceControl.kilometers',
  },
  [CONSTANTS.KEY_ID_LITER]: {
    key: CONSTANTS.KEY_ID_LITER,
    label: CONSTANTS.KEY_ID_LITER,
    commonkeyGroup: 'UNITS',
    fontClass: 'unit-trig-key-sm',
    ariaLabelKey: 'voiceControl.liters',
  },
  [CONSTANTS.KEY_ID_KG]: {
    key: CONSTANTS.KEY_ID_KG,
    label: CONSTANTS.KEY_ID_KG,
    commonkeyGroup: 'UNITS',
    ariaLabelKey: 'voiceControl.kilograms',
  },
  [CONSTANTS.KEY_ID_EURO]: {
    key: CONSTANTS.KEY_ID_EURO,
    label: CONSTANTS.KEY_ID_EURO,
    commonkeyGroup: 'UNITS',
    ariaLabelKey: 'voiceControl.euros',
  },
  [CONSTANTS.KEY_ID_BR_POUND]: {
    key: CONSTANTS.KEY_ID_BR_POUND,
    label: CONSTANTS.KEY_ID_BR_POUND,
    commonkeyGroup: 'UNITS',
    ariaLabelKey: 'voiceControl.poundSterling',
  },
  [CONSTANTS.KEY_ID_YEN]: {
    key: CONSTANTS.KEY_ID_YEN,
    label: CONSTANTS.KEY_ID_YEN,
    commonkeyGroup: 'UNITS',
    ariaLabelKey: 'voiceControl.yen',
  },
  [CONSTANTS.KEY_ID_AM]: {
    key: CONSTANTS.KEY_ID_AM,
    label: CONSTANTS.KEY_ID_AM,
    commonkeyGroup: 'UNITS',
    fontClass: 'f-20',
    ariaLabelKey: 'voiceControl.am',
  },
  [CONSTANTS.KEY_ID_PM]: {
    key: CONSTANTS.KEY_ID_PM,
    label: CONSTANTS.KEY_ID_PM,
    commonkeyGroup: 'UNITS',
    fontClass: 'f-20',
    ariaLabelKey: 'voiceControl.pm',
  },
  [CONSTANTS.KEY_ID_MONEY_Q]: {
    key: CONSTANTS.KEY_ID_MONEY_Q,
    label: CONSTANTS.KEY_ID_MONEY_Q,
    commonkeyGroup: 'UNITS',
    ariaLabelKey: 'voiceControl.quarter',
  },
  [CONSTANTS.KEY_ID_MONEY_D]: {
    key: CONSTANTS.KEY_ID_MONEY_D,
    label: CONSTANTS.KEY_ID_MONEY_D,
    commonkeyGroup: 'UNITS',
    ariaLabelKey: 'voiceControl.dime',
  },
  [CONSTANTS.KEY_ID_MONEY_N]: {
    key: CONSTANTS.KEY_ID_MONEY_N,
    label: CONSTANTS.KEY_ID_MONEY_N,
    commonkeyGroup: 'UNITS',
    ariaLabelKey: 'voiceControl.nickel',
  },
  [CONSTANTS.KEY_ID_MONEY_P]: {
    key: CONSTANTS.KEY_ID_MONEY_P,
    label: CONSTANTS.KEY_ID_MONEY_P,
    commonkeyGroup: 'UNITS',
    ariaLabelKey: 'voiceControl.penny',
  },
  [CONSTANTS.KEY_ID_ABC]: {
    key: CONSTANTS.KEY_ID_ABC,
    label: CONSTANTS.KEY_ID_ABC,
    commonkeyGroup: '',
    tooltipText: 'Add text',
    ariaLabelKey: 'voiceControl.startTextMode',
  },
  [CONSTANTS.KEY_ID_SUMMATION]: {
    key: CONSTANTS.KEY_ID_SUMMATION,
    label: CONSTANTS.KEY_ID_SUMMATION,
    commonkeyGroup: 'SUMMATION',
    fontClass: 'f-summation',
    ariaLabelKey: 'voiceControl.summation',
  },
  [CONSTANTS.KEY_ID_SUMMATION_1]: {
    key: CONSTANTS.KEY_ID_SUMMATION_1,
    label: '<img src="assets/images/Summation-icon-02.svg" aria-hidden="true" alt="" class="lg_summation" />',
    commonkeyGroup: 'SUMMATION',
    ariaLabelKey: 'voiceControl.summationWithLimits',
  },
  [CONSTANTS.KEY_ID_SUMMATION_2]: {
    key: CONSTANTS.KEY_ID_SUMMATION_2,
    label: '<img src="assets/images/summation-icon-03.svg" aria-hidden="true" alt="" class="lg_summation_2" />',
    commonkeyGroup: 'SUMMATION',
    ariaLabelKey: 'voiceControl.limit',
  },
  [CONSTANTS.KEY_ID_INTEGRAL]: {
    key: CONSTANTS.KEY_ID_INTEGRAL,
    label: CONSTANTS.KEY_ID_INTEGRAL,
    commonkeyGroup: 'SUMMATION',
    fontClass: 'f-cambria',
    ariaLabelKey: 'voiceControl.indefiniteIntegral',
  },
  [CONSTANTS.KEY_ID_INTEGRAL_1]: {
    key: CONSTANTS.KEY_ID_INTEGRAL_1,
    label: '<img src="assets/images/integral.svg" aria-hidden="true" alt="" class="integral-img" />',
    commonkeyGroup: 'SUMMATION',
    ariaLabelKey: 'voiceControl.integral',
  },
  [CONSTANTS.KEY_ID_VERTICAL_LINE]: {
    key: CONSTANTS.KEY_ID_VERTICAL_LINE,
    label: '<img src="assets/images/sumsix.svg" aria-hidden="true" alt="" class="integral-img" />',
    commonkeyGroup: 'SUMMATION',
    ariaLabelKey: 'voiceControl.evaluatedAt',
  },
  [CONSTANTS.KEY_ID_LINE]: {
    key: CONSTANTS.KEY_ID_LINE,
    label: '<img src="assets/images/line-1.svg" aria-hidden="true" />',
    commonkeyGroup: 'LINE',
    fontClass: 'enlarge_img',
    ariaLabelKey: 'voiceControl.answerLine',
  },
  [CONSTANTS.KEY_ID_PI]: {
    key: CONSTANTS.KEY_ID_PI,
    label: CONSTANTS.KEY_ID_PI,
    commonkeyGroup: 'MISC',
    fontClass: 'f-cambria',
    ariaLabelKey: 'voiceControl.pi',
  },
  [CONSTANTS.KEY_ID_INFINITY]: {
    key: CONSTANTS.KEY_ID_INFINITY,
    label: CONSTANTS.KEY_ID_INFINITY,
    commonkeyGroup: 'MISC',
    fontClass: 'f-verdana',
    ariaLabelKey: 'voiceControl.infinity',
  },
  [CONSTANTS.KEY_ID_E]: {
    key: CONSTANTS.KEY_ID_E,
    label: CONSTANTS.KEY_ID_E,
    commonkeyGroup: 'MISC',
    fontClass: 'f-calibri f-italic',
    ariaLabelKey: 'voiceControl.e',
  },
  [CONSTANTS.KEY_ID_I]: {
    key: CONSTANTS.KEY_ID_I,
    label: CONSTANTS.KEY_ID_I,
    commonkeyGroup: 'MISC',
    fontClass: 'f-calibri f-italic',
    ariaLabelKey: 'voiceControl.imaginaryI',
  },
  [CONSTANTS.KEY_ID_AVOGADRO]: {
    key: CONSTANTS.KEY_ID_AVOGADRO,
    label: '6.023x10²³',
    commonkeyGroup: 'MISC',
    fontClass: 'f-calibri f-8',
    ariaLabelKey: 'voiceControl.avogadro',
  },
  [CONSTANTS.KEY_ID_COLON]: {
    key: CONSTANTS.KEY_ID_COLON,
    label: CONSTANTS.KEY_ID_COLON,
    commonkeyGroup: 'MISC',
    ariaLabelKey: 'voiceControl.colon',
  },
  [CONSTANTS.KEY_ID_COMMA]: {
    key: CONSTANTS.KEY_ID_COMMA,
    label: CONSTANTS.KEY_ID_COMMA,
    commonkeyGroup: 'MISC',
    fontClass: 'f-cambria',
    ariaLabelKey: 'voiceControl.comma',
  },
  [CONSTANTS.KEY_ID_ABSOLUTE]: {
    key: CONSTANTS.KEY_ID_ABSOLUTE,
    label: CONSTANTS.KEY_ID_ABSOLUTE,
    commonkeyGroup: 'MISC',
    ariaLabelKey: 'voiceControl.absoluteValue',
  },
  [CONSTANTS.KEY_ID_ANGLE_VALUE]: {
    key: CONSTANTS.KEY_ID_ANGLE_VALUE,
    label: CONSTANTS.KEY_ID_ANGLE_VALUE,
    commonkeyGroup: 'MISC',
    fontClass: 'f-cambria',
    ariaLabelKey: 'voiceControl.angle',
  },
  [CONSTANTS.KEY_ID_CHECKMARK]: {
    key: CONSTANTS.KEY_ID_CHECKMARK,
    label: CONSTANTS.KEY_ID_CHECKMARK,
    commonkeyGroup: 'MISC',
    fontClass: 'f-wingdings',
    ariaLabelKey: 'voiceControl.checkmark',
  },
  [CONSTANTS.KEY_ID_UNION]: {
    key: CONSTANTS.KEY_ID_UNION,
    label: CONSTANTS.KEY_ID_UNION,
    commonkeyGroup: 'MISC',
    fontClass: 'f-cambria',
    ariaLabelKey: 'voiceControl.union',
  },
  [CONSTANTS.KEY_ID_INTERSECT]: {
    key: CONSTANTS.KEY_ID_INTERSECT,
    label: CONSTANTS.KEY_ID_INTERSECT,
    commonkeyGroup: 'MISC',
    fontClass: 'f-cambria',
    ariaLabelKey: 'voiceControl.intersection',
  },
  [CONSTANTS.KEY_ID_ELEMENT]: {
    key: CONSTANTS.KEY_ID_ELEMENT,
    label: CONSTANTS.KEY_ID_ELEMENT,
    commonkeyGroup: 'MISC',
    fontClass: 'f-cambria',
    ariaLabelKey: 'voiceControl.elementOf',
  },
  [CONSTANTS.KEY_ID_FACTORIAL]: {
    key: CONSTANTS.KEY_ID_FACTORIAL,
    label: CONSTANTS.KEY_ID_FACTORIAL,
    commonkeyGroup: 'MISC',
    fontClass: 'f-cambria',
    ariaLabelKey: 'voiceControl.factorial',
  },
  [CONSTANTS.KEY_ID_ANGLE]: {
    key: CONSTANTS.KEY_ID_ANGLE,
    label: CONSTANTS.KEY_ID_ANGLE,
    commonkeyGroup: 'MISC',
    ariaLabelKey: 'voiceControl.angleMeasure',
    fontClass: 'f-geo-noto',
  },
  [CONSTANTS.KEY_ID_PLUS_MINUS]: {
    key: CONSTANTS.KEY_ID_PLUS_MINUS,
    label: CONSTANTS.KEY_ID_PLUS_MINUS,
    commonkeyGroup: 'MISC',
    ariaLabelKey: 'voiceControl.plusMinus',
    // fontClass: 'f-cambria'
  },
  // [CONSTANTS.KEY_ID_DER_F]: {
  //   key: CONSTANTS.KEY_ID_DER_F,
  //   label: CONSTANTS.KEY_ID_DER_F,
  //   commonkeyGroup: 'MISC',
  //   // fontClass: 'f-cambria'
  // },
  [CONSTANTS.KEY_ID_DELTA]: {
    key: CONSTANTS.KEY_ID_DELTA,
    label: CONSTANTS.KEY_ID_DELTA,
    commonkeyGroup: 'MISC',
    ariaLabelKey: 'voiceControl.delta',
    // fontClass: 'f-cambria'
  },
  [CONSTANTS.KEY_ID_LEFT_ARROW]: {
    key: CONSTANTS.KEY_ID_LEFT_ARROW,
    label: CONSTANTS.KEY_ID_LEFT_ARROW,
    commonkeyGroup: 'MISC',
    fontClass: 'f-cambria',
    ariaLabelKey: 'voiceControl.leftArrow',
  },
  [CONSTANTS.KEY_ID_CHEM_ARROW]: {
    key: CONSTANTS.KEY_ID_CHEM_ARROW,
    label: CONSTANTS.KEY_ID_CHEM_ARROW,
    commonkeyGroup: 'MISC',
    fontClass: 'f-cambria',
    ariaLabelKey: 'voiceControl.rightArrow',
  },
  [CONSTANTS.KEY_ID_CHEM_DB_ARROW]: {
    key: CONSTANTS.KEY_ID_CHEM_DB_ARROW,
    label: CONSTANTS.KEY_ID_CHEM_DB_ARROW,
    commonkeyGroup: 'MISC',
    fontClass: 'f-cambria',
    ariaLabelKey: 'voiceControl.equilibriumArrow',
  },
  [CONSTANTS.KEY_ID_PAREN_LEFT]: {
    key: CONSTANTS.KEY_ID_PAREN_LEFT,
    label: CONSTANTS.KEY_ID_PAREN_LEFT,
    commonkeyGroup: 'BRACKET',
    ariaLabelKey: 'voiceControl.openParen',
  },
  [CONSTANTS.KEY_ID_PAREN_RIGHT]: {
    key: CONSTANTS.KEY_ID_PAREN_RIGHT,
    label: CONSTANTS.KEY_ID_PAREN_RIGHT,
    commonkeyGroup: 'BRACKET',
    ariaLabelKey: 'voiceControl.closeParen',
  },
  [CONSTANTS.KEY_ID_SQ_BRACKET_LEFT]: {
    key: CONSTANTS.KEY_ID_SQ_BRACKET_LEFT,
    label: CONSTANTS.KEY_ID_SQ_BRACKET_LEFT,
    commonkeyGroup: 'BRACKET',
    ariaLabelKey: 'voiceControl.openBracket',
  },
  [CONSTANTS.KEY_ID_SQ_BRACKET_RIGHT]: {
    key: CONSTANTS.KEY_ID_SQ_BRACKET_RIGHT,
    label: CONSTANTS.KEY_ID_SQ_BRACKET_RIGHT,
    commonkeyGroup: 'BRACKET',
    ariaLabelKey: 'voiceControl.closeBracket',
  },
  [CONSTANTS.KEY_ID_CURLY_LEFT]: {
    key: CONSTANTS.KEY_ID_CURLY_LEFT,
    label: CONSTANTS.KEY_ID_CURLY_LEFT,
    commonkeyGroup: 'BRACKET',
    ariaLabelKey: 'voiceControl.openBrace',
  },
  [CONSTANTS.KEY_ID_CURLY_RIGHT]: {
    key: CONSTANTS.KEY_ID_CURLY_RIGHT,
    label: CONSTANTS.KEY_ID_CURLY_RIGHT,
    commonkeyGroup: 'BRACKET',
    ariaLabelKey: 'voiceControl.closeBrace',
  },
  [CONSTANTS.KEY_ID_BLANK]: {
    key: CONSTANTS.KEY_ID_BLANK,
    label: CONSTANTS.KEY_ID_BLANK,
    commonkeyGroup: 'BLANK',
    fontClass: 'f-11',
  },
  [CONSTANTS.KEY_ID_DIVIDE_1]: {
    key: CONSTANTS.KEY_ID_DIVIDE_1,
    label: CONSTANTS.KEY_ID_DIVIDE_1,
    commonkeyGroup: 'OPERATOR',
    fontClass: 'f-cambria',
    ariaLabelKey: 'voiceControl.divide',
  },
  [CONSTANTS.KEY_ID_DIVIDE_2]: {
    key: CONSTANTS.KEY_ID_DIVIDE_2,
    label: CONSTANTS.KEY_ID_DIVIDE_2,
    commonkeyGroup: 'OPERATOR',
    fontClass: 'f-cambria f-32',
    ariaLabelKey: 'voiceControl.divide',
  },
  [CONSTANTS.KEY_ID_7]: {
    key: CONSTANTS.KEY_ID_7,
    label: CONSTANTS.KEY_ID_7,
    commonkeyGroup: 'NUMBER',
    ariaLabelKey: 'voiceControl.seven',
  },
  [CONSTANTS.KEY_ID_8]: {
    key: CONSTANTS.KEY_ID_8,
    label: CONSTANTS.KEY_ID_8,
    commonkeyGroup: 'NUMBER',
    ariaLabelKey: 'voiceControl.eight',
  },
  [CONSTANTS.KEY_ID_9]: {
    key: CONSTANTS.KEY_ID_9,
    label: CONSTANTS.KEY_ID_9,
    commonkeyGroup: 'NUMBER',
    ariaLabelKey: 'voiceControl.nine',
  },
  [CONSTANTS.KEY_ID_4]: {
    key: CONSTANTS.KEY_ID_4,
    label: CONSTANTS.KEY_ID_4,
    commonkeyGroup: 'NUMBER',
    ariaLabelKey: 'voiceControl.four',
  },
  [CONSTANTS.KEY_ID_5]: {
    key: CONSTANTS.KEY_ID_5,
    label: CONSTANTS.KEY_ID_5,
    commonkeyGroup: 'NUMBER',
    ariaLabelKey: 'voiceControl.five',
  },
  [CONSTANTS.KEY_ID_6]: {
    key: CONSTANTS.KEY_ID_6,
    label: CONSTANTS.KEY_ID_6,
    commonkeyGroup: 'NUMBER',
    ariaLabelKey: 'voiceControl.six',
  },
  [CONSTANTS.KEY_ID_MULTIPLY_3]: {
    key: CONSTANTS.KEY_ID_MULTIPLY_3,
    label: CONSTANTS.KEY_ID_MULTIPLY_3,
    commonkeyGroup: 'OPERATOR',
    fontClass: 'f-cambria',
    ariaLabelKey: 'voiceControl.times',
  },
  [CONSTANTS.KEY_ID_MULTIPLY_1]: {
    key: CONSTANTS.KEY_ID_MULTIPLY_1,
    label: CONSTANTS.KEY_ID_MULTIPLY_1,
    commonkeyGroup: 'OPERATOR',
    fontClass: 'f-cambria',
    ariaLabelKey: 'voiceControl.times',
  },
  [CONSTANTS.KEY_ID_MULTIPLY_2]: {
    key: CONSTANTS.KEY_ID_MULTIPLY_2,
    label: '<img src="assets/images/Dot.svg" aria-hidden="true" alt="" class="dot_label" />',
    commonkeyGroup: 'OPERATOR',
    fontClass: 'f-cambria f-32 p-abs',
    ariaLabelKey: 'voiceControl.times',
  },
  [CONSTANTS.KEY_ID_1]: {
    key: CONSTANTS.KEY_ID_1,
    label: CONSTANTS.KEY_ID_1,
    commonkeyGroup: 'NUMBER',
    ariaLabelKey: 'voiceControl.one',
  },
  [CONSTANTS.KEY_ID_2]: {
    key: CONSTANTS.KEY_ID_2,
    label: CONSTANTS.KEY_ID_2,
    commonkeyGroup: 'NUMBER',
    ariaLabelKey: 'voiceControl.two',
  },
  [CONSTANTS.KEY_ID_3]: {
    key: CONSTANTS.KEY_ID_3,
    label: CONSTANTS.KEY_ID_3,
    commonkeyGroup: 'NUMBER',
    ariaLabelKey: 'voiceControl.three',
  },
  [CONSTANTS.KEY_ID_MINUS]: {
    key: CONSTANTS.KEY_ID_MINUS,
    label: '<img src="assets/images/Subtract.svg" aria-hidden="true" alt="" class="minus"/>',
    labelBold: `<img src="assets/images/subtract-bold.svg" aria-hidden="true" alt="" class="minus"/>`,
    commonkeyGroup: 'OPERATOR',
    ariaLabelKey: 'voiceControl.minus',
  },
  [CONSTANTS.KEY_ID_NEGATIVE_SIGN]: {
    key: CONSTANTS.KEY_ID_NEGATIVE_SIGN,
    label: '<img src="assets/images/Subtract.svg" aria-hidden="true" alt="" class="_top-side" />',
    labelBold: `<img src="assets/images/negative-sign-bold.svg" aria-hidden="true" alt="" class="_top-side">`,
    commonkeyGroup: 'SPECIAL',
    ariaLabelKey: 'voiceControl.negative',
  },
  [CONSTANTS.KEY_ID_0]: {
    key: CONSTANTS.KEY_ID_0,
    label: CONSTANTS.KEY_ID_0,
    commonkeyGroup: 'NUMBER',
    ariaLabelKey: 'voiceControl.zero',
  },
  [CONSTANTS.KEY_ID_DECIMAL]: {
    key: CONSTANTS.KEY_ID_DECIMAL,
    label: CONSTANTS.KEY_ID_DECIMAL,
    labelBold: `<img src="assets/images/dot-bold.svg"  width="10" height="10"
    class='mt-4' aria-hidden="true" alt="" />`,
    commonkeyGroup: 'SPECIAL',
    fontClass: 'f-lato',
    ariaLabelKey: 'voiceControl.point',
  },
  [CONSTANTS.KEY_ID_PLUS]: {
    key: CONSTANTS.KEY_ID_PLUS,
    label: CONSTANTS.KEY_ID_PLUS,
    commonkeyGroup: 'OPERATOR',
    ariaLabelKey: 'voiceControl.plus',
  },
  [CONSTANTS.KEY_ID_LESS_THAN]: {
    key: CONSTANTS.KEY_ID_LESS_THAN,
    label: CONSTANTS.KEY_ID_LESS_THAN,
    commonkeyGroup: 'INQ_TYPE',
    fontClass: 'f-verdana geo-ineq-key-sm',
    ariaLabelKey: 'voiceControl.lessThan',
  },
  [CONSTANTS.KEY_ID_LESS_THAN_EQ]: {
    key: CONSTANTS.KEY_ID_LESS_THAN_EQ,
    label: CONSTANTS.KEY_ID_LESS_THAN_EQ,
    commonkeyGroup: 'INQ_TYPE',
    fontClass: 'f-verdana geo-ineq-key-sm',
    ariaLabelKey: 'voiceControl.lessOrEqual',
  },
  [CONSTANTS.KEY_ID_GREATER_THAN]: {
    key: CONSTANTS.KEY_ID_GREATER_THAN,
    label: CONSTANTS.KEY_ID_GREATER_THAN,
    commonkeyGroup: 'INQ_TYPE',
    fontClass: 'f-verdana geo-ineq-key-sm',
    ariaLabelKey: 'voiceControl.greaterThan',
  },
  [CONSTANTS.KEY_ID_GREATER_THAN_EQ]: {
    key: CONSTANTS.KEY_ID_GREATER_THAN_EQ,
    label: CONSTANTS.KEY_ID_GREATER_THAN_EQ,
    commonkeyGroup: 'INQ_TYPE',
    fontClass: 'f-verdana geo-ineq-key-sm',
    ariaLabelKey: 'voiceControl.greaterOrEqual',
  },
  [CONSTANTS.KEY_ID_EQUAL]: {
    key: CONSTANTS.KEY_ID_EQUAL,
    label: CONSTANTS.KEY_ID_EQUAL,
    commonkeyGroup: 'INQ_TYPE',
    fontClass: 'f-verdana',
    ariaLabelKey: 'voiceControl.equals',
  },
  [CONSTANTS.KEY_ID_NOT_EQUAL]: {
    key: CONSTANTS.KEY_ID_NOT_EQUAL,
    label: CONSTANTS.KEY_ID_NOT_EQUAL,
    commonkeyGroup: 'INQ_TYPE',
    fontClass: 'f-verdana',
    ariaLabelKey: 'voiceControl.notEqual',
  },
  [CONSTANTS.KEY_ID_APPROX_EQUAL]: {
    key: CONSTANTS.KEY_ID_APPROX_EQUAL,
    label: CONSTANTS.KEY_ID_APPROX_EQUAL,
    commonkeyGroup: 'INQ_TYPE',
    fontClass: 'f-verdana',
    ariaLabelKey: 'voiceControl.approximatelyEqual',
  },
  [CONSTANTS.KEY_ID_SQRT]: {
    key: CONSTANTS.KEY_ID_SQRT,
    label: '<img src="assets/images/square-root-01.svg" aria-hidden="true" alt="" />',
    commonkeyGroup: 'SQRT',
    ariaLabelKey: 'voiceControl.squareRoot',
  },
  [CONSTANTS.KEY_ID_DIVISION]: {
    key: CONSTANTS.KEY_ID_DIVISION,
    label: '<img src="assets/images/square-root-03.svg" aria-hidden="true" alt="" />',
    commonkeyGroup: 'SQRT',
    ariaLabelKey: 'voiceControl.longDivision',
  },
  [CONSTANTS.KEY_ID_ROOT]: {
    key: CONSTANTS.KEY_ID_ROOT,
    label: '<img src="assets/images/square-root-02.svg" aria-hidden="true" alt="" />',
    commonkeyGroup: 'SQRT',
    ariaLabelKey: 'voiceControl.nthRoot',
  },
  [CONSTANTS.KEY_ID_EXPONENT]: {
    key: CONSTANTS.KEY_ID_EXPONENT,
    label: '<img src="assets/images/Exponent-icon.svg" class="Exponent" aria-hidden="true" alt="" title="Exponent"/>',
    commonkeyGroup: 'EXPO',
    fontClass: 'expo-first',
    ariaLabelKey: 'voiceControl.power',
  },
  [CONSTANTS.KEY_ID_EXPONENT_GRID]: {
    key: CONSTANTS.KEY_ID_EXPONENT_GRID,
    label: '',
    commonkeyGroup: 'EXPO',
    fontClass: 'expo-first',
  },
  [CONSTANTS.KEY_ID_EXPONENT_1]: {
    key: CONSTANTS.KEY_ID_EXPONENT_1,
    label: '<img src="assets/images/Subscript-icon.svg" class="Exponent" aria-hidden="true" alt="" title="subscript"/>',
    commonkeyGroup: 'EXPO',
    fontClass: 'expo-sec',
    ariaLabelKey: 'voiceControl.subscript',
  },
  [CONSTANTS.KEY_ID_EXPONENT_2]: {
    key: CONSTANTS.KEY_ID_EXPONENT_2,
    label: '<img src="assets/images/Subscript-icon2.svg" class="Exponent" aria-hidden="true" alt="" title="subscript"/>',
    commonkeyGroup: 'EXPO',
    fontClass: 'expo-thrid',
    ariaLabelKey: 'voiceControl.superscriptLeft',
  },
  [CONSTANTS.KEY_ID_FRACTION]: {
    key: CONSTANTS.KEY_ID_FRACTION,
    label: `<img src="assets/images/Fraction.svg" aria-hidden="true" alt=""  title="Fraction"/>`,
    commonkeyGroup: 'FRACTION',
    ariaLabelKey: 'voiceControl.fraction',
  },
  [CONSTANTS.KEY_ID_FRACTION_GRID]: {
    key: CONSTANTS.KEY_ID_FRACTION_GRID_SIGN,
    label: `<img src="assets/images/grid-fraction.svg" aria-hidden="true" alt=""  title="Fraction Grid"/>`,
    commonkeyGroup: 'FRACTION',
  },
  [CONSTANTS.KEY_ID_FRACTION_GRID_SIGN]: {
    key: CONSTANTS.KEY_ID_FRACTION_GRID_SIGN,
    label: `<img src="assets/images/grid-fraction.svg" aria-hidden="true" alt=""  title="Fraction Grid"/>`,
    commonkeyGroup: 'FRACTION_GRID_SIGN',
  },
  [CONSTANTS.KEY_ID_X]: {
    key: CONSTANTS.KEY_ID_X,
    label: CONSTANTS.KEY_ID_X,
    commonkeyGroup: 'VAR',
    ariaLabelKey: 'voiceControl.x',
  },
  [CONSTANTS.KEY_ID_Y]: {
    key: CONSTANTS.KEY_ID_Y,
    label: CONSTANTS.KEY_ID_Y,
    commonkeyGroup: 'VAR',
    ariaLabelKey: 'voiceControl.y',
  },
  [CONSTANTS.KEY_ID_Z]: {
    key: CONSTANTS.KEY_ID_Z,
    label: CONSTANTS.KEY_ID_Z,
    commonkeyGroup: 'VAR',
    ariaLabelKey: 'voiceControl.z',
  },
  [CONSTANTS.KEY_ID_W]: {
    key: CONSTANTS.KEY_ID_W,
    label: CONSTANTS.KEY_ID_W,
    commonkeyGroup: 'VAR',
    ariaLabelKey: 'voiceControl.w',
  },
  [CONSTANTS.KEY_ID_A]: {
    key: CONSTANTS.KEY_ID_A,
    label: CONSTANTS.KEY_ID_A,
    commonkeyGroup: 'VAR',
    ariaLabelKey: 'voiceControl.a',
  },
  [CONSTANTS.KEY_ID_B]: {
    key: CONSTANTS.KEY_ID_B,
    label: CONSTANTS.KEY_ID_B,
    commonkeyGroup: 'VAR',
    ariaLabelKey: 'voiceControl.b',
  },
  [CONSTANTS.KEY_ID_C]: {
    key: CONSTANTS.KEY_ID_C,
    label: CONSTANTS.KEY_ID_C,
    commonkeyGroup: 'VAR',
    ariaLabelKey: 'voiceControl.c',
  },
  [CONSTANTS.KEY_ID_N]: {
    key: CONSTANTS.KEY_ID_N,
    label: CONSTANTS.KEY_ID_N,
    commonkeyGroup: 'VAR',
    ariaLabelKey: 'voiceControl.n',
  },
  [CONSTANTS.KEY_ID_H]: {
    key: CONSTANTS.KEY_ID_H,
    label: CONSTANTS.KEY_ID_H,
    commonkeyGroup: 'VAR',
    ariaLabelKey: 'voiceControl.h',
  },
  [CONSTANTS.KEY_ID_R]: {
    key: CONSTANTS.KEY_ID_R,
    label: CONSTANTS.KEY_ID_R,
    commonkeyGroup: 'VAR',
    ariaLabelKey: 'voiceControl.r',
  },
  [CONSTANTS.KEY_ID_S]: {
    key: CONSTANTS.KEY_ID_S,
    label: CONSTANTS.KEY_ID_S,
    commonkeyGroup: 'VAR',
    ariaLabelKey: 'voiceControl.s',
  },
  [CONSTANTS.KEY_ID_T]: {
    key: CONSTANTS.KEY_ID_T,
    label: CONSTANTS.KEY_ID_T,
    commonkeyGroup: 'VAR',
    ariaLabelKey: 'voiceControl.t',
  },
  [CONSTANTS.KEY_ID_FX]: {
    key: CONSTANTS.KEY_ID_FX,
    label: CONSTANTS.KEY_ID_FX,
    commonkeyGroup: 'VAR',
    fontClass: 'f-20',
    ariaLabelKey: 'voiceControl.fOfX',
  },
  [CONSTANTS.KEY_ID_P]: {
    key: CONSTANTS.KEY_ID_P,
    label: CONSTANTS.KEY_ID_P,
    commonkeyGroup: 'VAR',
    ariaLabelKey: 'voiceControl.p',
  },
  [CONSTANTS.KEY_ID_THETA]: {
    key: CONSTANTS.KEY_ID_THETA,
    label: CONSTANTS.KEY_ID_THETA,
    commonkeyGroup: 'VAR',
    ariaLabelKey: 'voiceControl.theta',
  },
  [CONSTANTS.KEY_ID_MU]: {
    key: CONSTANTS.KEY_ID_MU,
    label: CONSTANTS.KEY_ID_MU,
    commonkeyGroup: 'VAR',
    ariaLabelKey: 'voiceControl.mu',
  },
  [CONSTANTS.KEY_ID_SPACE]: {
    key: CONSTANTS.KEY_ID_SPACE,
    label: '<img src="assets/images/space.svg" aria-hidden="true" alt="" class="line-syb4" title="space"/>',
    labelBold: `<img src="assets/images/space-bold.svg" lt="Space character icon" class="line-syb4" title="space" />`,
    commonkeyGroup: 'SPECIAL',
    ariaLabelKey: 'voiceControl.space',
  },
  [CONSTANTS.KEY_ID_TAB]: {
    key: CONSTANTS.KEY_ID_TAB,
    label: '<img src="assets/images/tab.svg" aria-hidden="true" alt="" class="tab"/>',
    commonkeyGroup: 'SPECIAL',
    ariaLabelKey: 'voiceControl.tab',
  },
  [CONSTANTS.KEY_ID_TAB_EQUAL]: {
    key: CONSTANTS.KEY_ID_TAB_EQUAL,
    label: '<img src="assets/images/tab-equal.svg" aria-hidden="true" alt="" class="tab"/>',
    commonkeyGroup: 'SPECIAL',
    ariaLabelKey: 'voiceControl.tabToEquals',
  },
  [CONSTANTS.KEY_ID_X_SQR]: {
    key: CONSTANTS.KEY_ID_X_SQR,
    label: CONSTANTS.KEY_ID_X_SQR,
    commonkeyGroup: 'VAR_SQR',
    fontClass: 'f-verdana',
    ariaLabelKey: 'voiceControl.xSquared',
  },
  [CONSTANTS.KEY_ID_Y_SQR]: {
    key: CONSTANTS.KEY_ID_Y_SQR,
    label: CONSTANTS.KEY_ID_Y_SQR,
    commonkeyGroup: 'VAR_SQR',
    fontClass: 'f-verdana',
    ariaLabelKey: 'voiceControl.ySquared',
  },
  [CONSTANTS.KEY_ID_Z_SQR]: {
    key: CONSTANTS.KEY_ID_Z_SQR,
    label: CONSTANTS.KEY_ID_Z_SQR,
    commonkeyGroup: 'VAR_SQR',
    fontClass: 'f-verdana',
    ariaLabelKey: 'voiceControl.zSquared',
  },
  [CONSTANTS.KEY_ID_A_SQR]: {
    key: CONSTANTS.KEY_ID_A_SQR,
    label: CONSTANTS.KEY_ID_A_SQR,
    commonkeyGroup: 'VAR_SQR',
    fontClass: 'f-verdana',
    ariaLabelKey: 'voiceControl.aSquared',
  },
  [CONSTANTS.KEY_ID_B_SQR]: {
    key: CONSTANTS.KEY_ID_B_SQR,
    label: CONSTANTS.KEY_ID_B_SQR,
    commonkeyGroup: 'VAR_SQR',
    fontClass: 'f-verdana',
    ariaLabelKey: 'voiceControl.bSquared',
  },
  [CONSTANTS.KEY_ID_C_SQR]: {
    key: CONSTANTS.KEY_ID_C_SQR,
    label: CONSTANTS.KEY_ID_C_SQR,
    commonkeyGroup: 'VAR_SQR',
    fontClass: 'f-verdana',
    ariaLabelKey: 'voiceControl.cSquared',
  },
  [CONSTANTS.KEY_ID_R_SQR]: {
    key: CONSTANTS.KEY_ID_R_SQR,
    label: CONSTANTS.KEY_ID_R_SQR,
    commonkeyGroup: 'VAR_SQR',
    fontClass: 'f-verdana',
    ariaLabelKey: 'voiceControl.rSquared',
  },
  [CONSTANTS.KEY_ID_T_SQR]: {
    key: CONSTANTS.KEY_ID_T_SQR,
    label: CONSTANTS.KEY_ID_T_SQR,
    commonkeyGroup: 'VAR_SQR',
    fontClass: 'f-verdana',
    ariaLabelKey: 'voiceControl.tSquared',
  },
  [CONSTANTS.KEY_ID_N_SQR]: {
    key: CONSTANTS.KEY_ID_N_SQR,
    label: CONSTANTS.KEY_ID_N_SQR,
    commonkeyGroup: 'VAR_SQR',
    fontClass: 'f-verdana',
    ariaLabelKey: 'voiceControl.nSquared',
  },
  [CONSTANTS.KEY_ID_E_EXPONENT]: {
    key: CONSTANTS.KEY_ID_E_EXPONENT,
    label: `<img src="assets/images/Natural-log-exponent.svg" aria-hidden="true" alt="" class="exponent" />`,
    commonkeyGroup: 'EXPO',
  },
  [CONSTANTS.KEY_ID_LN]: {
    key: CONSTANTS.KEY_ID_LN,
    label: CONSTANTS.KEY_ID_LN,
    commonkeyGroup: 'LOG',
    fontClass: 'f-verdana f-20',
  },
  [CONSTANTS.KEY_ID_LOG]: {
    key: CONSTANTS.KEY_ID_LOG,
    label: `<img src="assets/images/Log-01.svg" aria-hidden="true" alt="" class="log" />`,
    commonkeyGroup: 'LOG',
  },
  [CONSTANTS.KEY_ID_LOG_A]: {
    key: CONSTANTS.KEY_ID_LOG_A,
    label: `<img src="assets/images/Log-02.svg" aria-hidden="true" alt="" class="loga" />`,
    commonkeyGroup: 'LOG',
  },
  [CONSTANTS.KEY_ID_SIN]: {
    key: CONSTANTS.KEY_ID_SIN,
    label: CONSTANTS.KEY_ID_SIN,
    commonkeyGroup: 'TRIG',
    fontClass: 'unit-trig-key-sm',
  },
  [CONSTANTS.KEY_ID_COS]: {
    key: CONSTANTS.KEY_ID_COS,
    label: CONSTANTS.KEY_ID_COS,
    commonkeyGroup: 'TRIG',
    fontClass: 'unit-trig-key-sm',
  },
  [CONSTANTS.KEY_ID_TAN]: {
    key: CONSTANTS.KEY_ID_TAN,
    label: CONSTANTS.KEY_ID_TAN,
    commonkeyGroup: 'TRIG',
    fontClass: 'unit-trig-key-sm',
  },
  [CONSTANTS.KEY_ID_CSC]: {
    key: CONSTANTS.KEY_ID_CSC,
    label: CONSTANTS.KEY_ID_CSC,
    commonkeyGroup: 'TRIG',
  },
  [CONSTANTS.KEY_ID_SEC]: {
    key: CONSTANTS.KEY_ID_SEC,
    label: CONSTANTS.KEY_ID_SEC,
    commonkeyGroup: 'TRIG',
  },
  [CONSTANTS.KEY_ID_COT]: {
    key: CONSTANTS.KEY_ID_COT,
    label: CONSTANTS.KEY_ID_COT,
    commonkeyGroup: 'TRIG',
  },
  [CONSTANTS.KEY_ID_SIN_SQR]: {
    key: CONSTANTS.KEY_ID_SIN_SQR,
    label: CONSTANTS.KEY_ID_SIN_SQR,
    commonkeyGroup: 'TRIG',
  },
  [CONSTANTS.KEY_ID_COS_SQR]: {
    key: CONSTANTS.KEY_ID_COS_SQR,
    label: CONSTANTS.KEY_ID_COS_SQR,
    commonkeyGroup: 'TRIG',
  },
  [CONSTANTS.KEY_ID_TAN_SQR]: {
    key: CONSTANTS.KEY_ID_TAN_SQR,
    label: CONSTANTS.KEY_ID_TAN_SQR,
    commonkeyGroup: 'TRIG',
  },
  [CONSTANTS.KEY_ID_CSC_SQR]: {
    key: CONSTANTS.KEY_ID_CSC_SQR,
    label: CONSTANTS.KEY_ID_CSC_SQR,
    commonkeyGroup: 'TRIG',
  },
  [CONSTANTS.KEY_ID_SEC_SQR]: {
    key: CONSTANTS.KEY_ID_SEC_SQR,
    label: CONSTANTS.KEY_ID_SEC_SQR,
    commonkeyGroup: 'TRIG',
  },
  [CONSTANTS.KEY_ID_COT_SQR]: {
    key: CONSTANTS.KEY_ID_COT_SQR,
    label: CONSTANTS.KEY_ID_COT_SQR,
    commonkeyGroup: 'TRIG',
  },
  [CONSTANTS.KEY_ID_INVERSE_SIN]: {
    key: CONSTANTS.KEY_ID_INVERSE_SIN,
    label: CONSTANTS.KEY_ID_INVERSE_SIN,
    commonkeyGroup: 'TRIG',
    fontClass: 'unit-trig-key-xs',
  },
  [CONSTANTS.KEY_ID_INVERSE_COS]: {
    key: CONSTANTS.KEY_ID_INVERSE_COS,
    label: CONSTANTS.KEY_ID_INVERSE_COS,
    commonkeyGroup: 'TRIG',
    fontClass: 'unit-trig-key-xs',
  },
  [CONSTANTS.KEY_ID_INVERSE_TAN]: {
    key: CONSTANTS.KEY_ID_INVERSE_TAN,
    label: CONSTANTS.KEY_ID_INVERSE_TAN,
    commonkeyGroup: 'TRIG',
    fontClass: 'unit-trig-key-xs',
  },
  [CONSTANTS.KEY_ID_INVERSE_CSC]: {
    key: CONSTANTS.KEY_ID_INVERSE_CSC,
    label: CONSTANTS.KEY_ID_INVERSE_CSC,
    commonkeyGroup: 'TRIG',
  },
  [CONSTANTS.KEY_ID_INVERSE_SEC]: {
    key: CONSTANTS.KEY_ID_INVERSE_SEC,
    label: CONSTANTS.KEY_ID_INVERSE_SEC,
    commonkeyGroup: 'TRIG',
  },
  [CONSTANTS.KEY_ID_INVERSE_COT]: {
    key: CONSTANTS.KEY_ID_INVERSE_COT,
    label: CONSTANTS.KEY_ID_INVERSE_COT,
    commonkeyGroup: 'TRIG',
  },
  [CONSTANTS.KEY_ID_CROSSOFF_1]: {
    key: CONSTANTS.KEY_ID_CROSSOFF_1,
    label: '<img src="assets/images/n-cross-grey.svg" aria-hidden="true" alt="" title="Cross-off" />',
    commonkeyGroup: 'CROSS_OF',
    ariaLabelKey: 'voiceControl.crossOff',
  },
  [CONSTANTS.KEY_ID_CROSSOFF_2]: {
    key: CONSTANTS.KEY_ID_CROSSOFF_2,
    label: '<img src="assets/images/n-cross-grey-with-yellow.svg" aria-hidden="true" alt="" class="" title="carry"/>',
    commonkeyGroup: 'CROSS_OF',
    ariaLabelKey: 'voiceControl.regroup',
  },
  [CONSTANTS.KEY_ID_CROSSOFF_3]: {
    key: CONSTANTS.KEY_ID_CROSSOFF_3,
    label: '<img src="assets/images/n-cross-blue-yellow.svg" aria-hidden="true" alt=""  title="borrow"/>',
    commonkeyGroup: 'CROSS_OF',
    ariaLabelKey: 'voiceControl.addRegroup',
  },
  DIV_LEVEL_1_2: {
    key: CONSTANTS.KEY_ID_DIVISION,
    label: '<img src="assets/images/long-division.svg" aria-hidden="true" alt="" class="long_division" />',
    commonkeyGroup: 'SQRT',
    ariaLabelKey: 'voiceControl.longDivision',
  },
  [CONSTANTS.KEY_ID_EMPTY]: {
    key: CONSTANTS.KEY_ID_EMPTY,
    label: '',
    commonkeyGroup: '',
    fontClass: '',
  },
  [CONSTANTS.KEY_ID_DX]: {
    key: CONSTANTS.KEY_ID_DX,
    label: CONSTANTS.KEY_ID_DX,
    commonkeyGroup: 'KEY_ID_DX',
    fontClass: 'f-20',
  },
  [CONSTANTS.KEY_ID_DER_1]: {
    key: CONSTANTS.KEY_ID_DER_1,
    label: '<img src="assets/images/dxy.svg" aria-hidden="true" alt="" class="dxdt" title="dx"/>',
    commonkeyGroup: 'KEY_ID_DX',
    // fontClass: 'expo-thrid',
  },
  [CONSTANTS.KEY_ID_DER_2]: {
    key: CONSTANTS.KEY_ID_DER_2,
    label: '<img src="assets/images/dodx.svg" aria-hidden="true" alt="" class="dxdt" title="dx"/>',
    commonkeyGroup: 'KEY_ID_DX',
    // fontClass: 'expo-thrid',
  },
  [CONSTANTS.KEY_ID_DER_3]: {
    key: CONSTANTS.KEY_ID_DER_3,
    label: '<img src="assets/images/ddt.svg" aria-hidden="true" alt="" class="dxdt" title="dx"/>',
    commonkeyGroup: 'KEY_ID_DX',
    // fontClass: 'expo-thrid',
  },
  [CONSTANTS.KEY_ID_DER_4]: {
    key: CONSTANTS.KEY_ID_DER_4,
    label: '<img src="assets/images/d2dx2.svg" aria-hidden="true" alt="" class="dxdt" title="dx"/>',
    commonkeyGroup: 'KEY_ID_DT',
    // fontClass: 'expo-thrid',
  },
  [CONSTANTS.KEY_ID_DER_5]: {
    key: CONSTANTS.KEY_ID_DER_5,
    label: '<img src="assets/images/dydx.svg" aria-hidden="true" alt="" class="dxdt" title="dx"/>',
    commonkeyGroup: 'KEY_ID_DX',
    // fontClass: 'expo-thrid',
  },
  //The following two math key definitions are only used by canvas, to be able to access the math key
  // data structures to lookup group and type values when displaying from a saved file
  [CONSTANTS.KEY_ID_DER_D]: {
    key: CONSTANTS.KEY_ID_DER_D,
    label: CONSTANTS.KEY_ID_DER_D,
    commonkeyGroup: 'KEY_ID_DX',
    fontClass: 'f-20',
  },
  [CONSTANTS.KEY_ID_DER_D_SQR]: {
    key: CONSTANTS.KEY_ID_DER_D,
    label: CONSTANTS.KEY_ID_DER_D,
    commonkeyGroup: 'KEY_ID_DX',
    fontClass: 'f-20',
  },

  [CONSTANTS.KEY_ID_DY]: {
    key: CONSTANTS.KEY_ID_DY,
    label: CONSTANTS.KEY_ID_DY,
    commonkeyGroup: 'KEY_ID_DY',
    fontClass: 'f-20',
    ariaLabelKey: 'voiceControl.Dy',
  },
  [CONSTANTS.KEY_ID_DER_F]: {
    key: CONSTANTS.KEY_ID_DER_F,
    label: CONSTANTS.KEY_ID_DER_F,
    commonkeyGroup: 'KEY_ID_DY',
    fontClass: 'f-20',
    ariaLabelKey: 'voiceControl.fPrime',
  },
  [CONSTANTS.KEY_ID_DER_F2]: {
    key: CONSTANTS.KEY_ID_DER_F2,
    label: CONSTANTS.KEY_ID_DER_F2,
    commonkeyGroup: 'KEY_ID_DY',
    fontClass: 'f-20',
    ariaLabelKey: 'voiceControl.fDoublePrime',
  },
  [CONSTANTS.KEY_ID_DER_6]: {
    key: CONSTANTS.KEY_ID_DER_6,
    label: '<img src="assets/images/d2ydx2.svg" aria-hidden="true" alt="" class="dydt" title="dx"/>',
    commonkeyGroup: 'KEY_ID_DY',
    ariaLabelKey: 'voiceControl.dSquaredYOverDXSquared',
  },
  [CONSTANTS.KEY_ID_DT]: {
    key: CONSTANTS.KEY_ID_DT,
    label: CONSTANTS.KEY_ID_DT,
    commonkeyGroup: 'KEY_ID_DY',
    fontClass: 'f-20',
    ariaLabelKey: 'voiceControl.dT',
  },
  [CONSTANTS.KEY_ID_DER_7]: {
    key: CONSTANTS.KEY_ID_DER_7,
    label: '<img src="assets/images/d2ydt2.svg" aria-hidden="true" alt="" class="dydt" title="dx"/>',
    commonkeyGroup: 'KEY_ID_DY',
    ariaLabelKey: 'voiceControl.dSquaredYOverDTSquared',
  },

  // Geometry keyboard symbol entries
  [CONSTANTS.KEY_ID_TRIANGLE]: {
    key: CONSTANTS.KEY_ID_TRIANGLE,
    label: CONSTANTS.KEY_ID_TRIANGLE,
    commonkeyGroup: 'GEO_SHAPE',
    ariaLabelKey: 'voiceControl.triangle',
    fontClass: 'f-geo-noto',
  },
  [CONSTANTS.KEY_ID_GEO_CIRCLE]: {
    key: CONSTANTS.KEY_ID_GEO_CIRCLE,
    label: CONSTANTS.KEY_ID_GEO_CIRCLE,
    commonkeyGroup: 'GEO_SHAPE',
    ariaLabelKey: 'voiceControl.circle',
    fontClass: 'f-geo-noto',
  },
  [CONSTANTS.KEY_ID_CONGRUENT]: {
    key: CONSTANTS.KEY_ID_CONGRUENT,
    label: CONSTANTS.KEY_ID_CONGRUENT,
    commonkeyGroup: 'INQ_TYPE',
    ariaLabelKey: 'voiceControl.congruent',
    fontClass: 'f-geo-dejavu',
  },
  [CONSTANTS.KEY_ID_SIMILAR]: {
    key: CONSTANTS.KEY_ID_SIMILAR,
    label: CONSTANTS.KEY_ID_SIMILAR,
    commonkeyGroup: 'INQ_TYPE',
    ariaLabelKey: 'voiceControl.similar',
    fontClass: 'f-geo-dejavu',
  },
  [CONSTANTS.KEY_ID_PARALLEL]: {
    key: CONSTANTS.KEY_ID_PARALLEL,
    label: CONSTANTS.KEY_ID_PARALLEL,
    commonkeyGroup: 'GEO_SYMBOL',
    ariaLabelKey: 'voiceControl.parallel',
    fontClass: 'f-geo-noto',
  },
  [CONSTANTS.KEY_ID_PERPENDICULAR]: {
    key: CONSTANTS.KEY_ID_PERPENDICULAR,
    label: CONSTANTS.KEY_ID_PERPENDICULAR,
    commonkeyGroup: 'GEO_SYMBOL',
    ariaLabelKey: 'voiceControl.perpendicular',
    fontClass: 'f-geo-noto',
  },
  [CONSTANTS.KEY_ID_PRIME]: {
    key: CONSTANTS.KEY_ID_PRIME,
    label: CONSTANTS.KEY_ID_PRIME,
    commonkeyGroup: 'GEO_SYMBOL',
    ariaLabelKey: 'voiceControl.prime',
    fontClass: 'f-geo-noto',
  },
  [CONSTANTS.KEY_ID_DOUBLE_PRIME]: {
    key: CONSTANTS.KEY_ID_DOUBLE_PRIME,
    label: CONSTANTS.KEY_ID_DOUBLE_PRIME,
    commonkeyGroup: 'GEO_SYMBOL',
    ariaLabelKey: 'voiceControl.doublePrime',
    fontClass: 'f-geo-noto',
  },
  [CONSTANTS.KEY_ID_MEASURE_ANGLE]: {
    key: CONSTANTS.KEY_ID_MEASURE_ANGLE,
    label: CONSTANTS.KEY_ID_MEASURE_ANGLE,
    commonkeyGroup: 'GEO_MEASURE',
    fontClass: 'geo-key-sm f-geo-noto',
    ariaLabelKey: 'voiceControl.measureAngle',
  },
  [CONSTANTS.KEY_ID_THEREFORE]: {
    key: CONSTANTS.KEY_ID_THEREFORE,
    label: CONSTANTS.KEY_ID_THEREFORE,
    commonkeyGroup: 'GEO_PROOF',
    ariaLabelKey: 'voiceControl.therefore',
    fontClass: 'f-geo-noto',
  },
  [CONSTANTS.KEY_ID_BECAUSE]: {
    key: CONSTANTS.KEY_ID_BECAUSE,
    label: CONSTANTS.KEY_ID_BECAUSE,
    commonkeyGroup: 'GEO_PROOF',
    ariaLabelKey: 'voiceControl.because',
    fontClass: 'f-geo-noto',
  },
  [CONSTANTS.KEY_ID_RIGHT_ANGLE]: {
    key: CONSTANTS.KEY_ID_RIGHT_ANGLE,
    label: CONSTANTS.KEY_ID_RIGHT_ANGLE,
    commonkeyGroup: 'GEO_SHAPE',
    ariaLabelKey: 'voiceControl.rightAngle',
    fontClass: 'f-geo-noto',
  },
  [CONSTANTS.KEY_ID_NOT_SIMILAR]: {
    key: CONSTANTS.KEY_ID_NOT_SIMILAR,
    label: CONSTANTS.KEY_ID_NOT_SIMILAR,
    commonkeyGroup: 'INQ_TYPE',
    fontClass: 'f-32 f-geo-dejavu',
    ariaLabelKey: 'voiceControl.notSimilar',
  },
  [CONSTANTS.KEY_ID_CAP_A]: {
    key: CONSTANTS.KEY_ID_CAP_A,
    label: CONSTANTS.KEY_ID_CAP_A,
    commonkeyGroup: 'VAR',
    ariaLabelKey: 'voiceControl.capA',
  },
  [CONSTANTS.KEY_ID_CAP_B]: {
    key: CONSTANTS.KEY_ID_CAP_B,
    label: CONSTANTS.KEY_ID_CAP_B,
    commonkeyGroup: 'VAR',
    ariaLabelKey: 'voiceControl.capB',
  },
  [CONSTANTS.KEY_ID_CAP_C]: {
    key: CONSTANTS.KEY_ID_CAP_C,
    label: CONSTANTS.KEY_ID_CAP_C,
    commonkeyGroup: 'VAR',
    ariaLabelKey: 'voiceControl.capC',
  },
  [CONSTANTS.KEY_ID_CAP_D]: {
    key: CONSTANTS.KEY_ID_CAP_D,
    label: CONSTANTS.KEY_ID_CAP_D,
    commonkeyGroup: 'VAR',
    ariaLabelKey: 'voiceControl.capD',
  },
  [CONSTANTS.KEY_ID_CAP_E]: {
    key: CONSTANTS.KEY_ID_CAP_E,
    label: CONSTANTS.KEY_ID_CAP_E,
    commonkeyGroup: 'VAR',
    ariaLabelKey: 'voiceControl.capE',
  },
  [CONSTANTS.KEY_ID_CAP_F]: {
    key: CONSTANTS.KEY_ID_CAP_F,
    label: CONSTANTS.KEY_ID_CAP_F,
    commonkeyGroup: 'VAR',
    ariaLabelKey: 'voiceControl.capF',
  },
  [CONSTANTS.KEY_ID_CAP_P]: {
    key: CONSTANTS.KEY_ID_CAP_P,
    label: CONSTANTS.KEY_ID_CAP_P,
    commonkeyGroup: 'VAR',
    ariaLabelKey: 'voiceControl.capP',
  },
  [CONSTANTS.KEY_ID_CAP_Q]: {
    key: CONSTANTS.KEY_ID_CAP_Q,
    label: CONSTANTS.KEY_ID_CAP_Q,
    commonkeyGroup: 'VAR',
    ariaLabelKey: 'voiceControl.capQ',
  },
  [CONSTANTS.KEY_ID_CAP_R]: {
    key: CONSTANTS.KEY_ID_CAP_R,
    label: CONSTANTS.KEY_ID_CAP_R,
    commonkeyGroup: 'VAR',
    ariaLabelKey: 'voiceControl.capR',
  },
  [CONSTANTS.KEY_ID_CAP_M]: {
    key: CONSTANTS.KEY_ID_CAP_M,
    label: CONSTANTS.KEY_ID_CAP_M,
    commonkeyGroup: 'VAR',
    ariaLabelKey: 'voiceControl.capM',
  },
  [CONSTANTS.KEY_ID_CAP_N]: {
    key: CONSTANTS.KEY_ID_CAP_N,
    label: CONSTANTS.KEY_ID_CAP_N,
    commonkeyGroup: 'VAR',
    ariaLabelKey: 'voiceControl.capN',
  },
  [CONSTANTS.KEY_ID_CAP_O]: {
    key: CONSTANTS.KEY_ID_CAP_O,
    label: CONSTANTS.KEY_ID_CAP_O,
    commonkeyGroup: 'VAR',
    ariaLabelKey: 'voiceControl.capO',
  },
  [CONSTANTS.KEY_ID_CAP_X]: {
    key: CONSTANTS.KEY_ID_CAP_X,
    label: CONSTANTS.KEY_ID_CAP_X,
    commonkeyGroup: 'VAR',
    ariaLabelKey: 'voiceControl.capX',
  },
  [CONSTANTS.KEY_ID_CAP_Y]: {
    key: CONSTANTS.KEY_ID_CAP_Y,
    label: CONSTANTS.KEY_ID_CAP_Y,
    commonkeyGroup: 'VAR',
    ariaLabelKey: 'voiceControl.capY',
  },
  [CONSTANTS.KEY_ID_CAP_Z]: {
    key: CONSTANTS.KEY_ID_CAP_Z,
    label: CONSTANTS.KEY_ID_CAP_Z,
    commonkeyGroup: 'VAR',
    ariaLabelKey: 'voiceControl.capZ',
  },
  [CONSTANTS.KEY_ID_CAP_G]: {
    key: CONSTANTS.KEY_ID_CAP_G,
    label: CONSTANTS.KEY_ID_CAP_G,
    commonkeyGroup: 'VAR',
    ariaLabelKey: 'voiceControl.capG',
  },
  [CONSTANTS.KEY_ID_CAP_H]: {
    key: CONSTANTS.KEY_ID_CAP_H,
    label: CONSTANTS.KEY_ID_CAP_H,
    commonkeyGroup: 'VAR',
    ariaLabelKey: 'voiceControl.capH',
  },
  [CONSTANTS.KEY_ID_CAP_I]: {
    key: CONSTANTS.KEY_ID_CAP_I,
    label: CONSTANTS.KEY_ID_CAP_I,
    commonkeyGroup: 'VAR',
    ariaLabelKey: 'voiceControl.capI',
  },
  [CONSTANTS.KEY_ID_D]: {
    key: CONSTANTS.KEY_ID_D,
    label: CONSTANTS.KEY_ID_D,
    commonkeyGroup: 'VAR',
    ariaLabelKey: 'voiceControl.lowerD',
  },
  [CONSTANTS.KEY_ID_M]: {
    key: CONSTANTS.KEY_ID_M,
    label: CONSTANTS.KEY_ID_M,
    commonkeyGroup: 'VAR',
    ariaLabelKey: 'voiceControl.lowerM',
  },
  [CONSTANTS.KEY_ID_L]: {
    key: CONSTANTS.KEY_ID_L,
    label: CONSTANTS.KEY_ID_L,
    commonkeyGroup: 'VAR',
    ariaLabelKey: 'voiceControl.lowerL',
  },
  [CONSTANTS.KEY_ID_K]: {
    key: CONSTANTS.KEY_ID_K,
    label: CONSTANTS.KEY_ID_K,
    commonkeyGroup: 'VAR',
    ariaLabelKey: 'voiceControl.lowerK',
  },
  [CONSTANTS.KEY_ID_GEO_LINE_SEG]: {
    key: CONSTANTS.KEY_ID_GEO_LINE_SEG,
    label: '<img src="assets/images/geo-line-seg.svg" aria-hidden="true" alt="" class="geo-line-seg" />',
    commonkeyGroup: 'GEO_OVER_TEXT',
    ariaLabelKey: 'voiceControl.lineSegment',
  },
  [CONSTANTS.KEY_ID_GEO_RAY]: {
    key: CONSTANTS.KEY_ID_GEO_RAY,
    label: '<img src="assets/images/geo-ray.svg" aria-hidden="true" alt="" class="geo-ray" />',
    commonkeyGroup: 'GEO_OVER_TEXT',
    ariaLabelKey: 'voiceControl.ray',
  },
  [CONSTANTS.KEY_ID_GEO_LINE]: {
    key: CONSTANTS.KEY_ID_GEO_LINE,
    label: '<img src="assets/images/geo-line.svg" aria-hidden="true" alt="" class="geo-line" />',
    commonkeyGroup: 'GEO_OVER_TEXT',
    ariaLabelKey: 'voiceControl.geoLine',
  },
  [CONSTANTS.KEY_ID_GEO_ARC]: {
    key: CONSTANTS.KEY_ID_GEO_ARC,
    label: '<img src="assets/images/geo-arc.svg" aria-hidden="true" alt="" class="geo-arc" />',
    commonkeyGroup: 'GEO_OVER_TEXT',
    ariaLabelKey: 'voiceControl.arc',
  },
  [CONSTANTS.KEY_ID_CM_SQR]: {
    key: CONSTANTS.KEY_ID_CM_SQR,
    label: CONSTANTS.KEY_ID_CM_SQR,
    commonkeyGroup: 'UNITS',
    fontClass: 'unit-trig-key-sm',
    ariaLabelKey: 'voiceControl.squareCentimeters',
  },
  [CONSTANTS.KEY_ID_M_SQR]: {
    key: CONSTANTS.KEY_ID_M_SQR,
    label: CONSTANTS.KEY_ID_M_SQR,
    commonkeyGroup: 'UNITS',
    fontClass: 'unit-trig-key-sm',
    ariaLabelKey: 'voiceControl.squareMeters',
  },
  [CONSTANTS.KEY_ID_IN_SQR]: {
    key: CONSTANTS.KEY_ID_IN_SQR,
    label: CONSTANTS.KEY_ID_IN_SQR,
    commonkeyGroup: 'UNITS',
    fontClass: 'unit-trig-key-sm',
    ariaLabelKey: 'voiceControl.squareInches',
  },
  [CONSTANTS.KEY_ID_FT_SQR]: {
    key: CONSTANTS.KEY_ID_FT_SQR,
    label: CONSTANTS.KEY_ID_FT_SQR,
    commonkeyGroup: 'UNITS',
    fontClass: 'unit-trig-key-sm',
    ariaLabelKey: 'voiceControl.squareFeet',
  },
  [CONSTANTS.KEY_ID_CM_CUBE]: {
    key: CONSTANTS.KEY_ID_CM_CUBE,
    label: CONSTANTS.KEY_ID_CM_CUBE,
    commonkeyGroup: 'UNITS',
    fontClass: 'unit-trig-key-sm',
    ariaLabelKey: 'voiceControl.cubicCentimeters',
  },
  [CONSTANTS.KEY_ID_M_CUBE]: {
    key: CONSTANTS.KEY_ID_M_CUBE,
    label: CONSTANTS.KEY_ID_M_CUBE,
    commonkeyGroup: 'UNITS',
    ariaLabelKey: 'voiceControl.cubicMeters',
  },
  [CONSTANTS.KEY_ID_IN_CUBE]: {
    key: CONSTANTS.KEY_ID_IN_CUBE,
    label: CONSTANTS.KEY_ID_IN_CUBE,
    commonkeyGroup: 'UNITS',
    fontClass: 'unit-trig-key-sm',
    ariaLabelKey: 'voiceControl.cubicInches',
  },
  [CONSTANTS.KEY_ID_FT_CUBE]: {
    key: CONSTANTS.KEY_ID_FT_CUBE,
    label: CONSTANTS.KEY_ID_FT_CUBE,
    commonkeyGroup: 'UNITS',
    ariaLabelKey: 'voiceControl.cubicFeet',
  },
  [CONSTANTS.KEY_ID_YD]: {
    key: CONSTANTS.KEY_ID_YD,
    label: CONSTANTS.KEY_ID_YD,
    commonkeyGroup: 'UNITS',
    fontClass: 'unit-trig-key-sm',
    ariaLabelKey: 'voiceControl.yards',
  },
  [CONSTANTS.KEY_ID_MI]: {
    key: CONSTANTS.KEY_ID_MI,
    label: CONSTANTS.KEY_ID_MI,
    commonkeyGroup: 'UNITS',
    fontClass: 'unit-trig-key-sm',
    ariaLabelKey: 'voiceControl.miles',
  },
  [CONSTANTS.KEY_ID_U]: {
    key: CONSTANTS.KEY_ID_U,
    label: CONSTANTS.KEY_ID_U,
    commonkeyGroup: 'UNITS',
    fontClass: 'unit-trig-key-sm',
    ariaLabelKey: 'voiceControl.units',
  },
  [CONSTANTS.KEY_ID_U_SQUARED]: {
    key: CONSTANTS.KEY_ID_U_SQUARED,
    label: CONSTANTS.KEY_ID_U_SQUARED,
    commonkeyGroup: 'UNITS',
    fontClass: 'unit-trig-key-sm',
    ariaLabelKey: 'voiceControl.squareUnits',
  },
  [CONSTANTS.KEY_ID_U_CUBE]: {
    key: CONSTANTS.KEY_ID_U_CUBE,
    label: CONSTANTS.KEY_ID_U_CUBE,
    commonkeyGroup: 'UNITS',
    fontClass: 'unit-trig-key-sm',
    ariaLabelKey: 'voiceControl.cubicUnits',
  },
};

export const MATH_KEYS_GROUP: { [key: string]: IMathKey } = {
  [BUTTON_ID.UNITS]: {
    selectedKey: MATH_KEYS[CONSTANTS.KEY_ID_CM],
    ...COMMON_KEYS.UNITS,
    buttonId: BUTTON_ID.UNITS,
  },
  [BUTTON_ID.ABC]: {
    selectedKey: MATH_KEYS[CONSTANTS.KEY_ID_ABC],
    type: CONSTANTS.CV_ABC_TYPE,
    group: CONSTANTS.CV_SPEC2_GRP,
    width: 6,
    alterKeys: [],
    buttonId: BUTTON_ID.ABC,
    className: 'abc_key',
  },
  [BUTTON_ID.BRACKET_LEFT]: {
    selectedKey: MATH_KEYS[CONSTANTS.KEY_ID_PAREN_LEFT],
    ...COMMON_KEYS.BRACKET,
    alterKeys: ALTER_KEYS.BRACKET_LEFT,
    buttonId: BUTTON_ID.BRACKET_LEFT,
  },
  [BUTTON_ID.BRACKET_RIGHT]: {
    selectedKey: MATH_KEYS[CONSTANTS.KEY_ID_PAREN_RIGHT],
    ...COMMON_KEYS.BRACKET,
    alterKeys: ALTER_KEYS.BRACKET_RIGHT,
    buttonId: BUTTON_ID.BRACKET_RIGHT,
  },
  [BUTTON_ID.CONSTANTS]: {
    selectedKey: MATH_KEYS[CONSTANTS.KEY_ID_PI],
    ...COMMON_KEYS.MISC,
    alterKeys: ALTER_KEYS.CONSTANTS.LEVEL_4,
    buttonId: BUTTON_ID.CONSTANTS,
  },
  [BUTTON_ID.MISC_MATH]: {
    selectedKey: MATH_KEYS[CONSTANTS.KEY_ID_COLON],
    ...COMMON_KEYS.MISC,
    alterKeys: ALTER_KEYS.MISC_MATH.LEVEL_4_3,
    buttonId: BUTTON_ID.MISC_MATH,
  },
  [BUTTON_ID.SUMMATION]: {
    selectedKey: MATH_KEYS[CONSTANTS.KEY_ID_SUMMATION],
    ...COMMON_KEYS.SUMMATION,
    buttonId: BUTTON_ID.SUMMATION,
  },
  [BUTTON_ID.LINE]: {
    selectedKey: MATH_KEYS[CONSTANTS.KEY_ID_LINE],
    ...COMMON_KEYS.LINE,
    buttonId: BUTTON_ID.LINE,
  },
  [BUTTON_ID.BLANK]: {
    selectedKey: MATH_KEYS[CONSTANTS.KEY_ID_BLANK],
    ...COMMON_KEYS.EMPTY,
    width: 6,
    alterKeys: ALTER_KEYS.BLANK,
    buttonId: BUTTON_ID.BLANK,
  },
  [CONSTANTS.KEY_ID_7]: {
    selectedKey: MATH_KEYS[CONSTANTS.KEY_ID_7],
    ...COMMON_KEYS.NUMBER,
    buttonId: CONSTANTS.KEY_ID_7,
  },
  [CONSTANTS.KEY_ID_8]: {
    selectedKey: MATH_KEYS[CONSTANTS.KEY_ID_8],
    ...COMMON_KEYS.NUMBER,
    buttonId: CONSTANTS.KEY_ID_8,
  },
  [CONSTANTS.KEY_ID_9]: {
    selectedKey: MATH_KEYS[CONSTANTS.KEY_ID_9],
    ...COMMON_KEYS.NUMBER,
    buttonId: CONSTANTS.KEY_ID_9,
  },
  [CONSTANTS.KEY_ID_4]: {
    selectedKey: MATH_KEYS[CONSTANTS.KEY_ID_4],
    ...COMMON_KEYS.NUMBER,
    buttonId: CONSTANTS.KEY_ID_4,
  },
  [CONSTANTS.KEY_ID_5]: {
    selectedKey: MATH_KEYS[CONSTANTS.KEY_ID_5],
    ...COMMON_KEYS.NUMBER,
    buttonId: CONSTANTS.KEY_ID_5,
  },
  [CONSTANTS.KEY_ID_6]: {
    selectedKey: MATH_KEYS[CONSTANTS.KEY_ID_6],
    ...COMMON_KEYS.NUMBER,
    buttonId: CONSTANTS.KEY_ID_6,
  },
  [CONSTANTS.KEY_ID_3]: {
    selectedKey: MATH_KEYS[CONSTANTS.KEY_ID_3],
    ...COMMON_KEYS.NUMBER,
    buttonId: CONSTANTS.KEY_ID_3,
  },
  [CONSTANTS.KEY_ID_2]: {
    selectedKey: MATH_KEYS[CONSTANTS.KEY_ID_2],
    ...COMMON_KEYS.NUMBER,
    buttonId: CONSTANTS.KEY_ID_2,
  },
  [CONSTANTS.KEY_ID_1]: {
    selectedKey: MATH_KEYS[CONSTANTS.KEY_ID_1],
    ...COMMON_KEYS.NUMBER,
    buttonId: CONSTANTS.KEY_ID_1,
  },
  [CONSTANTS.KEY_ID_0]: {
    selectedKey: MATH_KEYS[CONSTANTS.KEY_ID_0],
    ...COMMON_KEYS.NUMBER,
    buttonId: CONSTANTS.KEY_ID_0,
  },
  [BUTTON_ID.DIVIDE]: {
    selectedKey: MATH_KEYS[CONSTANTS.KEY_ID_DIVIDE_1],
    ...COMMON_KEYS.OPERATOR,
    alterKeys: ALTER_KEYS.DIVIDE.LEVEL_3_4_5,
    buttonId: BUTTON_ID.DIVIDE,
  },
  [BUTTON_ID.MULTIPLY]: {
    selectedKey: MATH_KEYS[CONSTANTS.KEY_ID_MULTIPLY_1],
    ...COMMON_KEYS.OPERATOR,
    alterKeys: ALTER_KEYS.MULTIPLY.LEVEL_3_4_5,
    buttonId: BUTTON_ID.MULTIPLY,
  },
  [BUTTON_ID.MINUS]: {
    selectedKey: MATH_KEYS[CONSTANTS.KEY_ID_MINUS],
    ...COMMON_KEYS.OPERATOR,
    className: '_number-yellow _minus',
    contrastClassName: '_number-yellow-contrast _minus',
    buttonId: BUTTON_ID.MINUS,
  },
  [BUTTON_ID.PLUS]: {
    selectedKey: MATH_KEYS[CONSTANTS.KEY_ID_PLUS],
    ...COMMON_KEYS.OPERATOR,
    className: '_number-yellow _size-big _plus f-27',
    contrastClassName: '_number-yellow-contrast _size-big _plus f-27',
    buttonId: BUTTON_ID.PLUS,
  },
  [BUTTON_ID.NEG]: {
    selectedKey: MATH_KEYS[CONSTANTS.KEY_ID_NEGATIVE_SIGN],
    ...COMMON_KEYS.SPECIAL,
    className: '_number-color _neg',
    contrastClassName: '_number-color-contrast _neg',
    buttonId: BUTTON_ID.NEG,
  },
  [BUTTON_ID.DECIMAL]: {
    selectedKey: MATH_KEYS[CONSTANTS.KEY_ID_DECIMAL],
    ...COMMON_KEYS.SPECIAL,
    className: '_number-color _size-big',
    contrastClassName: '_number-color-contrast _size-big',
    buttonId: BUTTON_ID.DECIMAL,
  },
  [BUTTON_ID.LESS_THAN]: {
    selectedKey: MATH_KEYS[CONSTANTS.KEY_ID_LESS_THAN],
    ...COMMON_KEYS.INQ_TYPE,
    alterKeys: ALTER_KEYS.LESS_THAN.LEVEL_3_4,
    buttonId: BUTTON_ID.LESS_THAN,
  },
  [BUTTON_ID.GREATER_THAN]: {
    selectedKey: MATH_KEYS[CONSTANTS.KEY_ID_GREATER_THAN],
    ...COMMON_KEYS.INQ_TYPE,
    alterKeys: ALTER_KEYS.GREATER_THAN,
    buttonId: BUTTON_ID.GREATER_THAN,
  },
  [BUTTON_ID.EQUAL]: {
    selectedKey: MATH_KEYS[CONSTANTS.KEY_ID_EQUAL],
    ...COMMON_KEYS.INQ_TYPE,
    width: 6,
    className: '_number-green _size-big',
    contrastClassName: '_number-green-contrast _size-big',
    alterKeys: ALTER_KEYS.EQUAL,
    buttonId: BUTTON_ID.EQUAL,
  },
  [BUTTON_ID.SQRT]: {
    selectedKey: MATH_KEYS[CONSTANTS.KEY_ID_SQRT],
    ...COMMON_KEYS.SQRT,
    alterKeys: ALTER_KEYS.SQRT,
    buttonId: BUTTON_ID.SQRT,
  },
  [BUTTON_ID.EXPO]: {
    selectedKey: MATH_KEYS[CONSTANTS.KEY_ID_EXPONENT],
    ...COMMON_KEYS.EXPO,
    alterKeys: ALTER_KEYS.EXPO,
    buttonId: BUTTON_ID.EXPO,
    alterKeysClass: '_expo',
  },
  [BUTTON_ID.EXPO_GRID]: {
    selectedKey: MATH_KEYS[CONSTANTS.KEY_ID_EXPONENT_GRID],
    ...COMMON_KEYS.EXPO,
    buttonId: BUTTON_ID.EXPO_GRID,
  },
  [BUTTON_ID.FRACTION]: {
    selectedKey: MATH_KEYS[CONSTANTS.KEY_ID_FRACTION],
    ...COMMON_KEYS.FRACTION,
    buttonId: BUTTON_ID.FRACTION,
  },
  [BUTTON_ID.FRACTION_GRID]: {
    selectedKey: MATH_KEYS[CONSTANTS.KEY_ID_FRACTION_GRID],
    ...COMMON_KEYS.FRACTION,
    buttonId: BUTTON_ID.FRACTION_GRID,
  },
  [BUTTON_ID.FRACTION_GRID_SIGN]: {
    selectedKey: MATH_KEYS[CONSTANTS.KEY_ID_FRACTION_GRID_SIGN],
    ...COMMON_KEYS.FRACTION_GRID_SIGN,
    buttonId: BUTTON_ID.FRACTION_GRID_SIGN,
  },
  [BUTTON_ID.VAR_X_3]: {
    selectedKey: MATH_KEYS[CONSTANTS.KEY_ID_X],
    ...COMMON_KEYS.VAR,
    alterKeys: ALTER_KEYS.VAR_X_3,
    buttonId: BUTTON_ID.VAR_X_3,
  },
  [BUTTON_ID.VAR_X_4]: {
    selectedKey: MATH_KEYS[CONSTANTS.KEY_ID_X],
    ...COMMON_KEYS.VAR,
    alterKeys: ALTER_KEYS.VAR_X_4,
    buttonId: BUTTON_ID.VAR_X_4,
  },
  [BUTTON_ID.VAR_Y_3]: {
    selectedKey: MATH_KEYS[CONSTANTS.KEY_ID_Y],
    ...COMMON_KEYS.VAR,
    alterKeys: ALTER_KEYS.VAR_Y_3,
    buttonId: BUTTON_ID.VAR_Y_3,
  },
  [BUTTON_ID.VAR_Y_4]: {
    selectedKey: MATH_KEYS[CONSTANTS.KEY_ID_Y],
    ...COMMON_KEYS.VAR,
    alterKeys: ALTER_KEYS.VAR_Y_4,
    buttonId: BUTTON_ID.VAR_Y_4,
  },
  [BUTTON_ID.VAR_Z]: {
    selectedKey: MATH_KEYS[CONSTANTS.KEY_ID_Z],
    ...COMMON_KEYS.VAR,
    alterKeys: ALTER_KEYS.VAR_Z,
    buttonId: BUTTON_ID.VAR_Z,
  },
  [BUTTON_ID.VAR_X_SQR]: {
    selectedKey: MATH_KEYS[CONSTANTS.KEY_ID_X_SQR],
    ...COMMON_KEYS.VAR_SQR,
    alterKeys: ALTER_KEYS.VAR_X_SQR,
    buttonId: BUTTON_ID.VAR_X_SQR,
  },
  [BUTTON_ID.EXPO_E]: {
    selectedKey: MATH_KEYS[CONSTANTS.KEY_ID_E_EXPONENT],
    ...COMMON_KEYS.EXPO,
    buttonId: BUTTON_ID.EXPO_E,
  },
  [BUTTON_ID.SPACE]: {
    selectedKey: MATH_KEYS[CONSTANTS.KEY_ID_SPACE],
    ...COMMON_KEYS.SPACE,
    className: '_size-big less-padding',
    buttonId: BUTTON_ID.SPACE,
  },
  [BUTTON_ID.ln]: {
    selectedKey: MATH_KEYS[CONSTANTS.KEY_ID_LN],
    ...COMMON_KEYS.LOG,
    buttonId: BUTTON_ID.ln,
  },
  [BUTTON_ID.log]: {
    selectedKey: MATH_KEYS[CONSTANTS.KEY_ID_LOG],
    ...COMMON_KEYS.LOG,
    alterKeys: ALTER_KEYS.LOG,
    buttonId: BUTTON_ID.log,
  },
  [BUTTON_ID.sin]: {
    selectedKey: MATH_KEYS[CONSTANTS.KEY_ID_SIN],
    ...COMMON_KEYS.TRIG,
    alterKeys: ALTER_KEYS.TRIG,
    buttonId: BUTTON_ID.sin,
  },
  [BUTTON_ID.cos]: {
    selectedKey: MATH_KEYS[CONSTANTS.KEY_ID_COS],
    ...COMMON_KEYS.TRIG,
    alterKeys: ALTER_KEYS.TRIG,
    buttonId: BUTTON_ID.cos,
  },
  [BUTTON_ID.tan]: {
    selectedKey: MATH_KEYS[CONSTANTS.KEY_ID_TAN],
    ...COMMON_KEYS.TRIG,
    alterKeys: ALTER_KEYS.TRIG,
    buttonId: BUTTON_ID.tan,
  },
  [BUTTON_ID.CROSS_OF]: {
    selectedKey: MATH_KEYS[CONSTANTS.KEY_ID_CROSSOFF_1],
    ...COMMON_KEYS.CROSS_OF,
    buttonId: BUTTON_ID.CROSS_OF,
    className: 'no-padding',
    alterKeys: ALTER_KEYS.CROSS_OF.LEVEL_OTHER,
  },
  [BUTTON_ID.DIVISION]: {
    selectedKey: MATH_KEYS.DIV_LEVEL_1_2,
    ...COMMON_KEYS.SQRT,
    buttonId: BUTTON_ID.DIVISION,
  },
  [BUTTON_ID.KEY_ID_DX]: {
    selectedKey: MATH_KEYS[CONSTANTS.KEY_ID_DX],
    ...COMMON_KEYS.DX,
    buttonId: BUTTON_ID.KEY_ID_DX,
  },
  [BUTTON_ID.KEY_ID_DY]: {
    selectedKey: MATH_KEYS[CONSTANTS.KEY_ID_DY],
    ...COMMON_KEYS.DY,
    buttonId: BUTTON_ID.KEY_ID_DY,
  },
  // Geometry keyboard buttons
  [BUTTON_ID.GEO_THEREFORE]: {
    selectedKey: MATH_KEYS[CONSTANTS.KEY_ID_THEREFORE],
    ...COMMON_KEYS.GEO_PROOF,
    alterKeys: ALTER_KEYS.GEO_THEREFORE,
    buttonId: BUTTON_ID.GEO_THEREFORE,
  },
  [BUTTON_ID.GEO_ANGLE]: {
    selectedKey: MATH_KEYS[CONSTANTS.KEY_ID_ANGLE],
    ...COMMON_KEYS.GEO_SYMBOL,
    buttonId: BUTTON_ID.GEO_ANGLE,
  },
  [BUTTON_ID.GEO_MEASURE_ANGLE]: {
    selectedKey: MATH_KEYS[CONSTANTS.KEY_ID_MEASURE_ANGLE],
    ...COMMON_KEYS.GEO_MEASURE,
    buttonId: BUTTON_ID.GEO_MEASURE_ANGLE,
  },
  [BUTTON_ID.GEO_TRIANGLE]: {
    selectedKey: MATH_KEYS[CONSTANTS.KEY_ID_TRIANGLE],
    ...COMMON_KEYS.GEO_SHAPE,
    alterKeys: ALTER_KEYS.GEO_TRIANGLE,
    buttonId: BUTTON_ID.GEO_TRIANGLE,
  },
  [BUTTON_ID.GEO_LINE_SEG]: {
    selectedKey: MATH_KEYS[CONSTANTS.KEY_ID_GEO_LINE_SEG],
    ...COMMON_KEYS.GEO_OVER_TEXT,
    alterKeys: ALTER_KEYS.GEO_LINE_SEG,
    buttonId: BUTTON_ID.GEO_LINE_SEG,
  },
  [BUTTON_ID.GEO_VAR_A]: {
    selectedKey: MATH_KEYS[CONSTANTS.KEY_ID_CAP_A],
    ...COMMON_KEYS.VAR,
    alterKeys: ALTER_KEYS.GEO_VAR_A,
    buttonId: BUTTON_ID.GEO_VAR_A,
  },
  [BUTTON_ID.GEO_VAR_B]: {
    selectedKey: MATH_KEYS[CONSTANTS.KEY_ID_CAP_B],
    ...COMMON_KEYS.VAR,
    alterKeys: ALTER_KEYS.GEO_VAR_B,
    buttonId: BUTTON_ID.GEO_VAR_B,
  },
  [BUTTON_ID.GEO_VAR_C]: {
    selectedKey: MATH_KEYS[CONSTANTS.KEY_ID_CAP_C],
    ...COMMON_KEYS.VAR,
    alterKeys: ALTER_KEYS.GEO_VAR_C,
    buttonId: BUTTON_ID.GEO_VAR_C,
  },
  [BUTTON_ID.GEO_PRIME]: {
    selectedKey: MATH_KEYS[CONSTANTS.KEY_ID_PRIME],
    ...COMMON_KEYS.GEO_SYMBOL,
    alterKeys: ALTER_KEYS.GEO_PRIME,
    buttonId: BUTTON_ID.GEO_PRIME,
  },
  [BUTTON_ID.GEO_PARALLEL]: {
    selectedKey: MATH_KEYS[CONSTANTS.KEY_ID_PARALLEL],
    ...COMMON_KEYS.GEO_SYMBOL,
    buttonId: BUTTON_ID.GEO_PARALLEL,
  },
  [BUTTON_ID.GEO_PERPENDICULAR]: {
    selectedKey: MATH_KEYS[CONSTANTS.KEY_ID_PERPENDICULAR],
    ...COMMON_KEYS.GEO_SYMBOL,
    buttonId: BUTTON_ID.GEO_PERPENDICULAR,
  },
  [BUTTON_ID.GEO_SIMILAR]: {
    selectedKey: MATH_KEYS[CONSTANTS.KEY_ID_SIMILAR],
    ...COMMON_KEYS.INQ_TYPE,
    alterKeys: [],
    buttonId: BUTTON_ID.GEO_SIMILAR,
  },
  [BUTTON_ID.GEO_CONGRUENT]: {
    selectedKey: MATH_KEYS[CONSTANTS.KEY_ID_CONGRUENT],
    ...COMMON_KEYS.INQ_TYPE,
    alterKeys: [],
    buttonId: BUTTON_ID.GEO_CONGRUENT,
  },
  [BUTTON_ID.GEO_RIGHT_ANGLE]: {
    selectedKey: MATH_KEYS[CONSTANTS.KEY_ID_RIGHT_ANGLE],
    ...COMMON_KEYS.GEO_SHAPE,
    buttonId: BUTTON_ID.GEO_RIGHT_ANGLE,
  },
};

export const GROUP_ALTERKEY_TO_SAVED = [
  BUTTON_ID.VAR_X_3,
  BUTTON_ID.VAR_X_4,
  BUTTON_ID.VAR_Y_3,
  BUTTON_ID.VAR_Y_4,
  BUTTON_ID.VAR_Z,
  BUTTON_ID.VAR_X_SQR,
  BUTTON_ID.DIVIDE,
  BUTTON_ID.MULTIPLY,
  BUTTON_ID.SQRT,
];
